<template>
    <div id="ContainerAddPatient">
        <div class="row page-height">
            <div class="col-12">
                <MdTitleRegInfo v-if="this.edit_mode && this.CountSave >= 0"
                    v-bind:RegistrationInfo="PatientTitle"
                    v-bind:titlePrefix="$t('Shared.PatientInformationHeader')"
                    v-bind:IsClinical="IsClinical"
                    v-bind:titleRef="'titleElementPatient'"
                    v-bind:patientCode="this.$route.params.id">
                </MdTitleRegInfo>

                <div class="alert alert-fill-warning d-flex align-items-center m-3" role="alert" v-if="isReadOnly">
                    <i class="mdi mdi-alert-circle me-2" style="font-size: 1.5rem;"></i>
                        <div class="flex-grow-1">
                            <span>{{ $t('Shared.ReadOnlyPermission') }}</span>
                        </div>
                </div>
                <h4 class="page-title text-truncate" v-if="!this.edit_mode && this.CountSave === 0">
                    {{ $t('PatientsList.addPatient') }}
                </h4>
                <div class="row">
					<div class="col-md-12 mx-auto">
                        <b-row>
                            <b-col lg="1" md="1" sm="12">
                                <MdEdit
                                    v-bind:Label="$t('Patient.Prefix')"
                                    v-bind:TypeProp="'text'"
                                    v-bind:Name="'patientcode'"
                                    v-bind:MaxLengthProp="10"
                                    v-model="patient.branchLocationPrefix"
                                    v-bind:isReadOnly="true"
                                    v-bind:Id="'input_patientPrefix_code'"
                                >
                                </MdEdit>
                            </b-col>
                            <b-col lg="2" md="2" sm="12">
                                <MdEdit
                                    v-bind:Label="$t('Shared.PatientCode')"
                                    v-bind:TypeProp="'text'"
                                    v-bind:Name="'patientcode'"
                                    v-bind:MaxLengthProp="10"
                                    v-model="patient.patientcode"
                                    v-bind:isReadOnly="true"
                                    v-bind:Id="'input_patient_code'"
                                >
                                </MdEdit>
                            </b-col>
                            <b-col lg="3" md="3" sm="12" v-if="this.isFieldVisible(formFieldsDictionary, 'branchLocation')">
                                <MdSelect 
                                    v-bind:Label="'Branch Location'"
                                    v-bind:Options="BranchLocationList"
                                    v-bind:FieldDescription="'description'"
                                    v-bind:FieldCode="'code'"
                                    v-bind:Tag="'BranchLocation'"
                                    v-bind:Model="BranchLocationModel"
                                    v-bind:AllowEmpty="false"
                                    v-bind:Multiple="false"
                                    :IsDisabled="isReadOnly"
                                    :Input="ChangeDropDownBranchLocation"
                                    v-bind:isRequired="this.isFieldRequired(formFieldsDictionary, 'branchLocation')"
                                    v-bind:isValid="this.isFieldValid(formFieldsDictionary, 'branchLocation')"
                                />
                            </b-col>
                            <b-col lg="3" md="3" sm="12" v-if="this.isFieldVisible(formFieldsDictionary, 'dob')">
                                <MdDateTime
                                    :Label="$t('Shared.Dob')"
                                    :Model="patient.dob"
                                    @input="patient.dob = $event"
                                    :Id="'PatientUAEDob'"
                                    :Type="'date'"
                                    :isConfirm="false"
                                    :ReadOnly="isReadOnly"
                                    v-bind:isRequired="this.isFieldRequired(formFieldsDictionary, 'dob')"
                                    v-bind:isValid="this.isFieldValid(formFieldsDictionary, 'dob')"
                                >
                                </MdDateTime>
                            </b-col>                                
                        </b-row>
                        <b-row>
                            <b-col lg="3" md="3" sm="12" v-if="this.isFieldVisible(formFieldsDictionary, 'lastName')">
                                <MdEdit
                                    v-bind:Label="$t('Patient.FamilyName')"
                                    v-bind:TypeProp="'text'"
                                    v-bind:Name="'Familyname'"
                                    v-bind:MaxLengthProp="100"
                                    v-model="patient.lastname"
                                    v-bind:isReadOnly="this.isReadOnly"
                                    v-bind:Id="'input_patient_family_name'"
                                    v-bind:isRequired="this.isFieldRequired(formFieldsDictionary, 'lastName')"
                                    v-bind:isValid="this.isFieldValid(formFieldsDictionary, 'lastName')"
                                >
                                </MdEdit>
                            </b-col>
                            <b-col lg="2" md="2" sm="12" v-if="this.isFieldVisible(formFieldsDictionary, 'firstName')">
                                <MdEdit
                                    v-bind:Label="$t('Shared.FirstName')"
                                    v-bind:TypeProp="'text'"
                                    v-bind:Name="'firstname'"
                                    v-bind:MaxLengthProp="100"
                                    v-model="patient.firstname"
                                    v-bind:isReadOnly="this.isReadOnly"
                                    v-bind:Id="'input_patient_first_name'"
                                    v-bind:isRequired="this.isFieldRequired(formFieldsDictionary, 'firstName')"
                                    v-bind:isValid="this.isFieldValid(formFieldsDictionary, 'firstName')"
                                >
                                </MdEdit>
                            </b-col>
                            <b-col lg="1" md="1" sm="12" v-if="this.isFieldVisible(formFieldsDictionary, 'fullMiddleName')">
                                <MdEdit
                                    v-bind:Label="$t('Patient.MiddleName')"
                                    v-bind:TypeProp="'text'"
                                    v-bind:Name="'middlename'"
                                    v-bind:MaxLengthProp="100"
                                    v-model="patient.fullMiddleName"
                                    v-bind:isReadOnly="this.isReadOnly"
                                    v-bind:Id="'input_patient_middlename'"
                                    v-bind:isRequired="this.isFieldRequired(formFieldsDictionary, 'fullMiddleName')"
                                    v-bind:isValid="this.isFieldValid(formFieldsDictionary, 'fullMiddleName')"
                                >
                                </MdEdit>
                            </b-col>
                            <b-col lg="3" md="3" sm="12" v-if="this.isFieldVisible(formFieldsDictionary, 'familyName')">
                                <MdEdit
                                    v-bind:Label="$t('Patient.ThirdName')"
                                    v-bind:TypeProp="'text'"
                                    v-bind:Name="'thirdname'"
                                    v-bind:MaxLengthProp="200"
                                    v-model="patient.familyName"
                                    v-bind:isReadOnly="this.isReadOnly"
                                    v-bind:Id="'input_patient_Thirdname'"
                                    v-bind:isRequired="this.isFieldRequired(formFieldsDictionary, 'familyName')"
                                    v-bind:isValid="this.isFieldValid(formFieldsDictionary, 'familyName')"
                                >
                                </MdEdit>
                            </b-col> 
                            <b-col lg="3" md="3" sm="12" v-if="this.isFieldVisible(formFieldsDictionary, 'fourthName')">
                                <MdEdit
                                    v-bind:Label="$t('Patient.FourthName')"
                                    v-bind:TypeProp="'text'"
                                    v-bind:Name="'Fourthname'"
                                    v-bind:MaxLengthProp="200"
                                    v-model="patient.fourthName"
                                    v-bind:isReadOnly="this.isReadOnly"
                                    v-bind:Id="'input_patient_Fourthname'"
                                    v-bind:isRequired="this.isFieldRequired(formFieldsDictionary, 'fourthName')"
                                    v-bind:isValid="this.isFieldValid(formFieldsDictionary, 'fourthName')"
                                >
                                </MdEdit>
                            </b-col>                                                               
                        </b-row>
                        <b-row>
                            <b-col lg="3" md="3" sm="12" v-if="this.isFieldVisible(formFieldsDictionary, 'lastNameAR')">
                                <MdEdit
                                    v-bind:Label="$t('Patient.FamilyNameArabic')"
                                    v-bind:TypeProp="'text'"
                                    v-bind:Name="'lastname'"
                                    v-bind:MaxLengthProp="200"
                                    v-arabic-only
                                    v-model="patient.lastNameAR"
                                    v-bind:isReadOnly="this.isReadOnly"
                                    v-bind:Id="'input_patient_last_nameArabic'"
                                    v-bind:isRequired="this.isFieldRequired(formFieldsDictionary, 'lastNameAR')"
                                    v-bind:isValid="this.isFieldValid(formFieldsDictionary, 'lastNameAR')"
                                >
                                </MdEdit>
                            </b-col>
                            <b-col lg="2" md="2" sm="12" v-if="this.isFieldVisible(formFieldsDictionary, 'firstNameAR')">
                                <MdEdit
                                    v-bind:Label="$t('Patient.FirstNameArabic')"
                                    v-bind:TypeProp="'text'"
                                    v-bind:Name="'firstname'"
                                    v-bind:MaxLengthProp="200"
                                    v-arabic-only
                                    v-model="patient.firstNameAR"
                                    v-bind:isReadOnly="this.isReadOnly"
                                    v-bind:Id="'input_patient_first_nameArabic'"
                                    v-bind:isRequired="this.isFieldRequired(formFieldsDictionary, 'firstNameAR')"
                                    v-bind:isValid="this.isFieldValid(formFieldsDictionary, 'firstNameAR')"
                                >
                                </MdEdit>
                            </b-col>
                            <b-col lg="1" md="1" sm="12" v-if="this.isFieldVisible(formFieldsDictionary, 'middleNameAR')">
                                <MdEdit
                                    v-bind:Label="$t('Patient.MiddleNameArabic')"
                                    v-bind:TypeProp="'text'"
                                    v-bind:Name="'middlename'"
                                    v-bind:MaxLengthProp="200"
                                    v-arabic-only
                                    v-model="patient.middleNameAR"
                                    v-bind:isReadOnly="this.isReadOnly"
                                    v-bind:Id="'input_patient_middlenameArabic_name'"
                                    v-bind:isRequired="this.isFieldRequired(formFieldsDictionary, 'middleNameAR')"
                                    v-bind:isValid="this.isFieldValid(formFieldsDictionary, 'middleNameAR')"
                                >
                                </MdEdit>
                            </b-col>
                            <b-col lg="3" md="3" sm="12" v-if="this.isFieldVisible(formFieldsDictionary, 'familyNameAR')">
                                <MdEdit
                                    v-bind:Label="$t('Patient.ThirdNameArabic')"
                                    v-bind:TypeProp="'text'"
                                    v-bind:Name="'thirdnameArabic'"
                                    v-bind:MaxLengthProp="200"
                                    v-arabic-only
                                    v-model="patient.familyNameAR"
                                    v-bind:isReadOnly="this.isReadOnly"
                                    v-bind:Id="'input_patient_ThirdnameArabic'"
                                    v-bind:isRequired="this.isFieldRequired(formFieldsDictionary, 'familyNameAR')"
                                    v-bind:isValid="this.isFieldValid(formFieldsDictionary, 'familyNameAR')"
                                >
                                </MdEdit>
                            </b-col>
                            <b-col lg="3" md="3" sm="12" v-if="this.isFieldVisible(formFieldsDictionary, 'fourthNameAR')">
                                <MdEdit
                                    v-bind:Label="$t('Patient.FourthNameArabic')"
                                    v-bind:TypeProp="'text'"
                                    v-bind:Name="'FourthnameArabic'"
                                    v-bind:MaxLengthProp="200"
                                    v-arabic-only
                                    v-model="patient.fourthNameAR"
                                    v-bind:isReadOnly="this.isReadOnly"
                                    v-bind:Id="'input_patient_FourthnameArabic'"
                                    v-bind:isRequired="this.isFieldRequired(formFieldsDictionary, 'fourthNameAR')"
                                    v-bind:isValid="this.isFieldValid(formFieldsDictionary, 'fourthNameAR')"
                                >
                                </MdEdit>
                            </b-col>                                                                
                        </b-row>
                        <b-row>
                            <b-col lg="2" md="2" sm="12">
                                <MdEdit
                                    v-bind:Label="$t('Patient.UAEID')"
                                    v-bind:TypeProp="'text'"
                                    v-bind:Mask="'###-####-#######-#'"
                                    v-bind:Placeholder="'###-####-#######-#'"
                                    v-bind:Name="'UAEID'"
                                    v-bind:MaxLengthProp="18"
                                    v-bind:isRequired="RequiredUAEID"
                                    v-model="patient.patientid"
                                    v-bind:isValid="isUAEIDValid"
                                    v-bind:isReadOnly="isReadOnly || ReadOnlyIfAllowEmpty"
                                    v-bind:Id="'input_patient_uaeid'"
                                >
                                </MdEdit>
                            </b-col>
                            <b-col lg="1" md="1" sm="12">
                                <MdCheckBox
                                    v-bind:Label="$t('Patient.AllowEmptyUAEID')"
                                    v-bind:Name="'checkbox-AllowEmptyUAEID'"
                                    v-bind:ClassProp="'AlignCheck'"
                                    v-bind:CheckedValue="true"
                                    v-bind:UncheckedValue="false"
                                    v-model="AllowEmptyUAEID"
                                    v-bind:isReadOnly="this.isReadOnly"
                                    v-on:change="onChangeAllowEmpty"
                                />
                            </b-col>
                            <b-col lg="3" md="3" sm="12" v-if="RequiredUAEID || this.isFieldVisible(formFieldsDictionary, 'uaeid_expdate')">
                                <MdDateTime
                                    :Label="$t('Patient.ExpDateUAE')"
                                    :Model="patient.uaeid_expdate"
                                    @input="patient.uaeid_expdate = $event"
                                    :Id="'PatientUAEExpDate'"
                                    :Type="'date'"
                                    :isConfirm="false"
                                    :ReadOnly="isReadOnly"
                                    v-bind:isRequired="RequiredUAEID && this.isFieldRequired(formFieldsDictionary, 'uaeid_expdate')"
                                    v-bind:isValid="!RequiredUAEID || this.isFieldValid(formFieldsDictionary, 'uaeid_expdate')"
                                >
                                </MdDateTime>
                            </b-col>
                            <b-col lg="3" md="3" sm="12" v-if="this.isFieldVisible(formFieldsDictionary, 'branch')">
                                <MdSelect
                                    v-bind:Label="$t('Patient.IdType')"
                                    v-bind:Options="IdTypeList"
                                    v-bind:FieldDescription="'text'"
                                    v-bind:FieldCode="'value'"
                                    v-bind:Model="patient.branch"
                                    v-bind:Multiple="false"
                                    v-bind:Tag="'IdType'"
                                    :IsDisabled="isReadOnly"
                                    :Input="ChangeDropDownIdType"
                                    v-bind:isRequired="this.isFieldRequired(formFieldsDictionary, 'branch')"
                                    v-bind:isValid="this.isFieldValid(formFieldsDictionary, 'branch')"
                                />
                            </b-col>
                            <b-col lg="3" md="3" sm="12" v-if="this.isFieldVisible(formFieldsDictionary, 'autho')">
                                <MdEdit
                                    v-bind:Label="$t('Patient.DocumentNo')"
                                    v-bind:TypeProp="'text'"
                                    v-bind:Name="'DocumentNo'"
                                    v-bind:MaxLengthProp="20"
                                    v-model="patient.autho"
                                    v-bind:isReadOnly="isReadOnly"
                                    v-bind:Id="'input_patient_Document'"
                                    v-bind:isRequired="this.isFieldRequired(formFieldsDictionary, 'autho')"
                                    v-bind:isValid="this.isFieldValid(formFieldsDictionary, 'autho')"
                                >
                                </MdEdit>
                            </b-col>                                
                        </b-row>
                        <b-row class="mt-2">
                            <b-col lg="3" md="3" sm="12" v-if="this.isFieldVisible(formFieldsDictionary, 'notActive')">
                                <MdRadioGroup
                                    v-bind:Label="$t('Patient.ActiveRecord')"
                                    v-model="patient.notActive"
                                    v-bind:Options="inactive_recods_list"
                                    v-bind:Name="'Active_Record'"
                                    v-bind:isReadOnly="isReadOnly"
                                    v-bind:isRequired="this.isFieldRequired(formFieldsDictionary, 'notActive')"
                                    v-bind:isValid="this.isFieldValid(formFieldsDictionary, 'notActive')"
                                />
                            </b-col>
                            <b-col lg="3" md="3" sm="12"  v-if="this.isFieldVisible(formFieldsDictionary, 'sgDate')">
                                <MdDateTime
                                    :Label="$t('Shared.AcceptedDate')"
                                    :Model="patient.sgDate"
                                    @input="patient.sgDate = $event"
                                    :Id="'PatientUAEAcceptedDate'"
                                    :Type="'date'"
                                    :isConfirm="false"
                                    :ReadOnly="isReadOnly"
                                    v-bind:isRequired="this.isFieldRequired(formFieldsDictionary, 'sgDate')"
                                    v-bind:isValid="this.isFieldValid(formFieldsDictionary, 'sgDate')"
                                >
                                </MdDateTime>
                            </b-col>                      
                            <b-col md="3" lg="3" sm="12" v-if="IsVip">
                                <MdCheckBox
                                    v-bind:Label="'Is Restricted'"
                                    v-bind:Name="'checkbox-IsVip'"
                                    v-bind:ClassProp="'AlignCheck'"
                                    v-bind:CheckedValue="true"
                                    v-bind:UncheckedValue="false"
                                    v-model="patient.isVIP"
                                    v-bind:isReadOnly="this.isReadOnly"
                                />
                            </b-col>
                            <b-col md="3" lg="3" sm="12" v-if="IsSpecialCase">
                                <MdCheckBox
                                    v-bind:Label="'Special Case'"
                                    v-bind:Name="'checkbox-SpecialCase'"
                                    v-bind:ClassProp="'AlignCheck'"
                                    v-bind:CheckedValue="true"
                                    v-bind:UncheckedValue="false"
                                    v-model="patient.isspecialcase"
                                    v-bind:isReadOnly="this.isReadOnly"
                                />
                            </b-col>                                       
                        </b-row>

                        <template v-if="isAddressSectionVisible">
                            <MdTitle v-bind:Text="this.$t('Shared.Address')"  v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
                            <b-row>
                                <b-col lg="3" md="3" sm="12" v-if="this.isFieldVisible(formFieldsDictionary, 'address1')">
                                    <MdEdit
                                        v-bind:Label="$t('Patient.StreetName')"
                                        v-bind:TypeProp="'text'"
                                        v-bind:Name="'address1'"
                                        v-bind:MaxLengthProp="30"
                                        v-model="patient.address1"
                                        v-bind:isReadOnly="isReadOnly"
                                        v-bind:Id="'input_patient_addr1'"
                                        v-bind:isRequired="this.isFieldRequired(formFieldsDictionary, 'address1')"
                                        v-bind:isValid="this.isFieldValid(formFieldsDictionary, 'address1')"
                                    >
                                    </MdEdit>
                                </b-col>
                                <b-col lg="3" md="3" sm="12" v-if="this.isFieldVisible(formFieldsDictionary, 'country')">
                                    <MdSelect
                                        v-bind:Label="$t('Patient.CountryofResidence')"
                                        v-bind:Options="CountryOfResidenceList"
                                        v-bind:FieldDescription="'name'"
                                        v-bind:FieldCode="'code'"
                                        v-bind:Model="this.CountryModel"
                                        v-bind:AllowEmpty="false"
                                        v-bind:RequireEvent="true"
                                        v-bind:Tag="'CountryofResidence'"
                                        v-bind:Multiple="false"
                                        :IsDisabled="isReadOnly"
                                        :Input="ChangeDropDownCountryOfResidence"
                                        v-bind:isRequired="this.isFieldRequired(formFieldsDictionary, 'country')"
                                        v-bind:isValid="this.isFieldValid(formFieldsDictionary, 'country')"
                                    />
                                </b-col>
                                <b-col lg="3" md="3" sm="12" v-if="this.isFieldVisible(formFieldsDictionary, 'state')">
                                    <MdSelect
                                        v-bind:Label="$t('Patient.Emirate')"
                                        v-bind:Options="EmirateList"
                                        v-bind:FieldDescription="'name'"
                                        v-bind:FieldCode="'code'"
                                        v-bind:Model="this.StateModel"
                                        v-bind:AllowEmpty="false"
                                        v-bind:Tag="'Emirate'"
                                        v-bind:Multiple="false"
                                        :IsDisabled="isReadOnly"
                                        :Input="ChangeDropDownEmirate"
                                        v-bind:isRequired="this.isFieldRequired(formFieldsDictionary, 'state')"
                                        v-bind:isValid="this.isFieldValid(formFieldsDictionary, 'state')"
                                    />
                                </b-col>
                                <b-col lg="3" md="3" sm="12" v-if="this.isFieldVisible(formFieldsDictionary, 'area')">
                                    <MdSelect
                                        v-bind:Label="$t('Patient.Area')"
                                        v-bind:Options="AreaList"
                                        v-bind:FieldDescription="'name'"
                                        v-bind:FieldCode="'code'"
                                        v-bind:Model="AreaModel"
                                        v-bind:AllowEmpty="false"
                                        v-bind:Tag="'Area'"
                                        v-bind:Multiple="false"
                                        :IsDisabled="isReadOnly"
                                        :Input="ChangeDropDownArea"
                                        v-bind:isRequired="this.isFieldRequired(formFieldsDictionary, 'area')"
                                        v-bind:isValid="this.isFieldValid(formFieldsDictionary, 'area')"
                                    />
                                </b-col>                        
                                <b-col lg="3" md="3" sm="12" v-if="this.isFieldVisible(formFieldsDictionary, 'city')">
                                    <MdSelect
                                        v-bind:Label="$t('Shared.City')"
                                        v-bind:Options="CityList"
                                        v-bind:FieldDescription="'name'"
                                        v-bind:FieldCode="'code'"
                                        v-bind:Model="CityModel"
                                        v-bind:Tag="'City'"
                                        v-bind:AllowEmpty="false"
                                        v-bind:Multiple="false"
                                        :IsDisabled="isReadOnly"
                                        :Input="ChangeDropDownCity"
                                        v-bind:isRequired="this.isFieldRequired(formFieldsDictionary, 'city')"
                                        v-bind:isValid="this.isFieldValid(formFieldsDictionary, 'city')"
                                    />
                                </b-col>
                            </b-row>
                        </template>

                        <template v-if="isContactInfoSectionVisible">
                            <MdTitle v-bind:Text="$t('Shared.ContactInformation')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'" />
                            <b-row class="groupingRow">
                                <b-col lg="2" md="2" sm="12" v-if="this.isFieldVisible(formFieldsDictionary, 'cellphone_countrycode')">
                                    <MdEdit
                                        v-bind:Label="'Country Code'"
                                        v-bind:TypeProp="'text'"
                                        v-bind:Name="'CountryCode'"
                                        v-bind:MaxLengthProp="25"
                                        v-model="patient.cellphone_countrycode"
                                        v-bind:isReadOnly="isReadOnly"
                                        v-bind:Id="'input_patientcountrycode3'"
                                        v-bind:isRequired="this.isFieldRequired(formFieldsDictionary, 'cellphone_countrycode')"
                                        v-bind:isValid="this.isFieldValid(formFieldsDictionary, 'cellphone_countrycode')"
                                    >
                                    </MdEdit>
                                </b-col>
                                <b-col lg="4" md="4" sm="12" v-if="this.isFieldVisible(formFieldsDictionary, 'cellPhone')">
                                    <MdEdit
                                        v-bind:Label="'Cell Phone'"
                                        v-bind:TypeProp="'text'"
                                        v-bind:Name="'Phone3'"
                                        v-bind:MaxLengthProp="20"
                                        v-model="patient.cellPhone"
                                        v-bind:isReadOnly="isReadOnly"
                                        v-bind:Id="'input_cellphone'"
                                        v-bind:isRequired="this.isFieldRequired(formFieldsDictionary, 'cellPhone')"
                                        v-bind:isValid="this.isFieldValid(formFieldsDictionary, 'cellPhone')"
                                    >
                                    </MdEdit>
                                </b-col>
                                <b-col lg="6" md="6" sm="12" v-if="this.isFieldVisible(formFieldsDictionary, 'cellphone_relation')">
                                    <MdSelect
                                        v-bind:Label="'RelationShip'"
                                        v-bind:Options="RelationList"
                                        v-bind:FieldDescription="'text'"
                                        v-bind:FieldCode="'value'"
                                        v-bind:Tag="'RelationShip'"
                                        v-bind:Model="patient.cellphone_relation"
                                        v-bind:Multiple="false"
                                        :IsDisabled="isReadOnly"
                                        :Input="ChangeDropDownRelationShip3"
                                        v-bind:isRequired="this.isFieldRequired(formFieldsDictionary, 'cellphone_relation')"
                                        v-bind:isValid="this.isFieldValid(formFieldsDictionary, 'cellphone_relation')"
                                    />
                                </b-col>
                            </b-row>
                            <b-row class="groupingRow">
                                <b-col lg="2" md="2" sm="12" v-if="this.isFieldVisible(formFieldsDictionary, 'day_phone_countrycode')">
                                    <MdEdit
                                        v-bind:Label="'Country Code'"
                                        v-bind:TypeProp="'text'"
                                        v-bind:Name="'CountryCode'"
                                        v-bind:MaxLengthProp="25"
                                        v-model="patient.day_phone_countrycode"
                                        v-bind:isReadOnly="isReadOnly"
                                        v-bind:Id="'input_patientcountrycode1'"
                                        v-bind:isRequired="this.isFieldRequired(formFieldsDictionary, 'day_phone_countrycode')"
                                        v-bind:isValid="this.isFieldValid(formFieldsDictionary, 'day_phone_countrycode')"
                                    >
                                    </MdEdit>
                                </b-col>
                                <b-col lg="4" md="4" sm="12" v-if="this.isFieldVisible(formFieldsDictionary, 'dayPhone')">
                                    <MdEdit
                                        v-bind:Label="'Phone 1'"
                                        v-bind:TypeProp="'text'"
                                        v-bind:Name="'Phone1'"
                                        v-bind:MaxLengthProp="20"
                                        v-model="patient.dayPhone"
                                        v-bind:isReadOnly="isReadOnly"
                                        v-bind:Id="'input_patientphone1'"
                                        v-bind:isRequired="this.isFieldRequired(formFieldsDictionary, 'dayPhone')"
                                        v-bind:isValid="this.isFieldValid(formFieldsDictionary, 'dayPhone')"
                                    >
                                    </MdEdit>
                                </b-col>
                                <b-col lg="6" md="6" sm="12" v-if="this.isFieldVisible(formFieldsDictionary, 'day_phone_relation')">
                                    <MdSelect
                                        v-bind:Label="'RelationShip'"
                                        v-bind:Options="RelationList"
                                        v-bind:FieldDescription="'text'"
                                        v-bind:FieldCode="'value'"
                                        v-bind:Tag="'RelationShip'"
                                        v-bind:Model="patient.day_phone_relation"
                                        v-bind:Multiple="false"
                                        :IsDisabled="isReadOnly"
                                        :Input="ChangeDropDownRelationShip1"
                                        v-bind:isRequired="this.isFieldRequired(formFieldsDictionary, 'day_phone_relation')"
                                        v-bind:isValid="this.isFieldValid(formFieldsDictionary, 'day_phone_relation')"
                                    />
                                </b-col>
                            </b-row>
                            <b-row class="groupingRow">
                                <b-col lg="2" md="2" sm="12" v-if="this.isFieldVisible(formFieldsDictionary, 'night_phone_countrycode')">
                                    <MdEdit
                                        v-bind:Label="'Country Code'"
                                        v-bind:TypeProp="'text'"
                                        v-bind:Name="'CountryCode'"
                                        v-bind:MaxLengthProp="25"
                                        v-model="patient.night_phone_countrycode"
                                        v-bind:isReadOnly="isReadOnly"
                                        v-bind:Id="'input_patientcountrycode2'"
                                        v-bind:isRequired="this.isFieldRequired(formFieldsDictionary, 'night_phone_countrycode')"
                                        v-bind:isValid="this.isFieldValid(formFieldsDictionary, 'night_phone_countrycode')"
                                    >
                                    </MdEdit>
                                </b-col>
                                <b-col lg="4" md="4" sm="12" v-if="this.isFieldVisible(formFieldsDictionary, 'nightPhone')">
                                    <MdEdit
                                        v-bind:Label="'Phone 2'"
                                        v-bind:TypeProp="'text'"
                                        v-bind:Name="'Phone2'"
                                        v-bind:MaxLengthProp="20"
                                        v-model="patient.nightPhone"
                                        v-bind:isReadOnly="isReadOnly"
                                        v-bind:Id="'input_patientphone2'"
                                        v-bind:isRequired="this.isFieldRequired(formFieldsDictionary, 'nightPhone')"
                                        v-bind:isValid="this.isFieldValid(formFieldsDictionary, 'nightPhone')"
                                    >
                                    </MdEdit>
                                </b-col>
                                <b-col lg="6" md="6" sm="12" v-if="this.isFieldVisible(formFieldsDictionary, 'night_phone_relation')">
                                    <MdSelect
                                        v-bind:Label="'RelationShip'"
                                        v-bind:Options="RelationList"
                                        v-bind:FieldDescription="'text'"
                                        v-bind:FieldCode="'value'"
                                        v-bind:Tag="'RelationShip'"
                                        v-bind:Model="patient.night_phone_relation"
                                        v-bind:Multiple="false"
                                        :IsDisabled="isReadOnly"
                                        :Input="ChangeDropDownRelationShip2"
                                        v-bind:isRequired="this.isFieldRequired(formFieldsDictionary, 'night_phone_relation')"
                                        v-bind:isValid="this.isFieldValid(formFieldsDictionary, 'night_phone_relation')"
                                    />
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col lg="3" md="3" sm="12" v-if="this.isFieldVisible(formFieldsDictionary, 'email')">
                                    <MdEdit
                                        v-bind:Label="$t('Shared.Email')"
                                        v-bind:TypeProp="'email'"
                                        v-bind:Name="'email'"
                                        v-bind:MaxLengthProp="100"
                                        v-model="patient.email"
                                        v-bind:isReadOnly="isReadOnly"
                                        v-bind:isValid="this.emailValid"
                                        v-bind:Id="'input_patient_email'"
                                        v-bind:isRequired="this.isFieldRequired(formFieldsDictionary, 'email')"
                                    >
                                    </MdEdit>
                                </b-col>
                            </b-row>
                        </template>

                        <template v-if="isGeneralSectionVisible">
                            <MdTitle v-bind:Text="this.$t('Shared.General')"  v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
                            <b-row>
                                <b-col lg="3" md="3" sm="12" v-if="this.isFieldVisible(formFieldsDictionary, 'sex')">
                                    <MdSelect
                                        v-bind:Label="$t('Shared.Gender')"
                                        v-bind:Options="gender_list"
                                        v-bind:FieldDescription="'text'"
                                        v-bind:FieldCode="'value'"
                                        v-bind:Model="patient.sex"
                                        v-bind:AllowEmpty="false"
                                        v-bind:Tag="'Gender'"
                                        v-bind:Multiple="false"
                                        :IsDisabled="isReadOnly"
                                        :Input="ChangeDropDownGender"
                                        v-bind:isRequired="this.isFieldRequired(formFieldsDictionary, 'sex')"
                                        v-bind:isValid="this.isFieldValid(formFieldsDictionary, 'sex')"
                                    />
                                </b-col>
                                <b-col lg="3" md="3" sm="12" v-if="this.isFieldVisible(formFieldsDictionary, 'married')">
                                    <MdSelect
                                        v-bind:Label="$t('Shared.MaritalStatus')"
                                        data-field="AdditionalInformation_MaritalStatus"
                                        v-bind:Options="marital_status_list"
                                        v-bind:FieldDescription="'text'"
                                        v-bind:FieldCode="'value'"
                                        v-bind:Model="patient.married"
                                        v-bind:Multiple="false"
                                        v-bind:Tag="'MaritalStatus'"
                                        :IsDisabled="isReadOnly"
                                        :Input="ChangeDropDownMaritalStatus"
                                        v-bind:isRequired="this.isFieldRequired(formFieldsDictionary, 'married')"
                                        v-bind:isValid="this.isFieldValid(formFieldsDictionary, 'married')"
                                    />
                                </b-col>
                                <b-col lg="3" md="3" sm="12" v-if="this.isFieldVisible(formFieldsDictionary, 'employed')">
                                    <MdSelect
                                        v-bind:Label="$t('Patient.Employment')"
                                        data-field="AdditionalInformation_Employment"
                                        v-bind:Options="employment_list"
                                        v-bind:FieldDescription="'text'"
                                        v-bind:FieldCode="'value'"
                                        v-bind:Model="EmployModel"
                                        v-bind:AllowEmpty="false"
                                        v-bind:Tag="'Employment'"
                                        v-bind:Multiple="false"
                                        :IsDisabled="isReadOnly"
                                        :Input="ChangeDropDownEmployment"
                                        v-bind:isRequired="this.isFieldRequired(formFieldsDictionary, 'employed')"
                                        v-bind:isValid="this.isFieldValid(formFieldsDictionary, 'employed')"
                                    />
                                </b-col>
                                <b-col lg="3" md="3" sm="12" v-if="this.isFieldVisible(formFieldsDictionary, 'employeddesc')">
                                    <MdEdit
                                        v-bind:Label="$t('Patient.EmploymentDescription')"
                                        v-bind:TypeProp="'text'"
                                        v-bind:Name="'EmploymentDescription'"
                                        v-bind:MaxLengthProp="255"
                                        v-model="patient.employeddesc"
                                        v-bind:isReadOnly="isReadOnly"
                                        v-bind:Id="'input_patient_EmploymentDescription'"
                                        v-bind:isRequired="this.isFieldRequired(formFieldsDictionary, 'employeddesc')"
                                        v-bind:isValid="this.isFieldValid(formFieldsDictionary, 'employeddesc')"
                                    >
                                    </MdEdit>
                                </b-col>
                                <b-col lg="3" md="3" sm="12" v-if="this.isFieldVisible(formFieldsDictionary, 'educationLevel')">
                                    <MdSelect
                                        v-bind:Label="$t('Patient.EducationLevel')"
                                        v-bind:Options="EducationLevelList"
                                        v-bind:FieldDescription="'text'"
                                        v-bind:FieldCode="'value'"
                                        v-bind:Model="patient.educationLevel"
                                        v-bind:AllowEmpty="false"
                                        v-bind:Multiple="false"
                                        v-bind:Tag="'EducationLevel'"
                                        :IsDisabled="isReadOnly"
                                        :Input="ChangeDropDownLevel"
                                        v-bind:isRequired="this.isFieldRequired(formFieldsDictionary, 'educationLevel')"
                                        v-bind:isValid="this.isFieldValid(formFieldsDictionary, 'educationLevel')"
                                    />
                                </b-col>
                                <b-col lg="3" md="3" sm="12" v-if="this.isFieldVisible(formFieldsDictionary, 'majorReligion')">
                                    <MdSelect
                                        v-bind:Label="$t('Patient.MajorReligion')"
                                        v-bind:Options="MajorReligionList"
                                        v-bind:FieldDescription="'description'"
                                        v-bind:FieldCode="'code'"
                                        v-bind:Model="patient.majorReligion"
                                        v-bind:Multiple="false"
                                        v-bind:Tag="'MajorReligion'"
                                        :IsDisabled="isReadOnly"
                                        :Input="ChangeDropDownMajorReligion"
                                        v-bind:isRequired="this.isFieldRequired(formFieldsDictionary, 'majorReligion')"
                                        v-bind:isValid="this.isFieldValid(formFieldsDictionary, 'majorReligion')"
                                    />
                                </b-col>                        
                                <b-col lg="3" md="3" sm="12" v-if="this.isFieldVisible(formFieldsDictionary, 'majorLanguage')">
                                    <MdSelect
                                        v-bind:Label="$t('Patient.PreferredLanguage')"
                                        v-bind:Options="PreferredLangList"
                                        v-bind:FieldDescription="'description'"
                                        v-bind:FieldCode="'code'"
                                        v-bind:Model="patient.majorLanguage"
                                        v-bind:Multiple="false"
                                        v-bind:Tag="'PreferredLanguage'"
                                        :IsDisabled="isReadOnly"
                                        :Input="ChangeDropDownPreferredLan"
                                        v-bind:isRequired="this.isFieldRequired(formFieldsDictionary, 'majorLanguage')"
                                        v-bind:isValid="this.isFieldValid(formFieldsDictionary, 'majorLanguage')"
                                    />
                                </b-col>

                                <b-col lg="3" md="3" sm="12" v-if="this.isFieldVisible(formFieldsDictionary, 'ethnicityCode')">
                                    <MdSelect
                                        v-bind:Label="$t('Patient.CountryofOrigin')"
                                        v-bind:Options="CountryOfOriginList"
                                        v-bind:FieldDescription="'name'"
                                        v-bind:FieldCode="'code'"
                                        v-bind:RequireEvent="true"
                                        v-bind:Tag="'CountryofOrigin'"
                                        v-bind:AllowEmpty="false"
                                        v-bind:Model="EthnicityModel"
                                        v-bind:Multiple="false"
                                        :IsDisabled="isReadOnly"
                                        :Input="ChangeDropDownCountryOfOrigin"
                                        v-bind:isRequired="this.isFieldRequired(formFieldsDictionary, 'ethnicityCode')"
                                        v-bind:isValid="this.isFieldValid(formFieldsDictionary, 'ethnicityCode')"
                                    />
                                </b-col>                        
                            </b-row>
                        </template>
                        <template v-if="isAdditionalSectionVisible">
                            <MdTitle v-bind:Text="this.$t('Shared.Additional')"  v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
                            <b-row>
                                <b-col lg="3" md="3" sm="12" v-if="this.isFieldVisible(formFieldsDictionary, 'referal')">
                                    <MdLookup
                                        v-bind:Label="$t('Patient.ReferralSource')"
                                        v-bind:ModelCode="patient.referal"
                                        v-bind:ModelDescription="ReferralFrom.description"
                                        v-bind:RefCode="'ReferralFrom'"
                                        v-bind:Api="'Referrals'"
                                        v-bind:FieldCode="'code'"
                                        v-bind:FieldDescription="'name'"
                                        :IsDisabled="this.isReadOnly"
                                        :SearchTitle="$t('Patient.ReferralFrom')"
                                        :GetValues="onCodeConditionOk"
                                        :InvalidFeedback="$t('Patient.InvalidReferralFromCode')"
                                        :SearchFieldCode="'Code'"
                                        v-bind:Fields="BaseFieldsReferido"
                                        v-bind:isRequired="this.isFieldRequired(formFieldsDictionary, 'referal')"
                                        v-bind:isValid="this.isFieldValid(formFieldsDictionary, 'referal')"
                                    />
                                </b-col>
                                <b-col lg="3" md="3" sm="12" v-if="this.isFieldVisible(formFieldsDictionary, 'referalTo')">
                                    <MdLookup
                                        v-bind:Label="$t('Patient.ReferralTo')"
                                        v-bind:ModelCode="patient.referalTo"
                                        v-bind:ModelDescription="ReferralTo.description"
                                        v-bind:RefCode="'ReferralTo'"
                                        v-bind:Api="'Referrals'"
                                        v-bind:FieldCode="'code'"
                                        v-bind:FieldDescription="'name'"
                                        :IsDisabled="this.isReadOnly"
                                        :SearchTitle="$t('Patient.ReferralTo')"
                                        :GetValues="onCodeConditionOk"
                                        :InvalidFeedback="$t('Patient.InvalidReferralToCode')"
                                        :SearchFieldCode="'Code'"
                                        v-bind:Fields="BaseFieldsReferido"
                                        v-bind:isRequired="this.isFieldRequired(formFieldsDictionary, 'referalTo')"
                                        v-bind:isValid="this.isFieldValid(formFieldsDictionary, 'referalTo')"
                                    />
                                </b-col>
                                <b-col lg="3" md="3" sm="12" v-if="!UseBlankDoctorCode">
                                    <MdLookup
                                        v-bind:Label="$t('Shared.AttendingDoctor')"
                                        v-bind:ModelCode="patient.doctorcode"
                                        v-bind:ModelDescription="AttendingDoctor.description"
                                        v-bind:RefCode="'AttendingDoctor'"
                                        v-bind:Api="'Doctors'"
                                        v-bind:FieldCode="'code'"
                                        v-bind:FieldDescription="'name'"
                                        :IsDisabled="this.isReadOnly"
                                        :SearchTitle="$t('Shared.Doctors')"
                                        :GetValues="onCodeConditionOk"
                                        :InvalidFeedback="$t('Patient.InvalidAttendingDoctor')"
                                        :SearchFieldCode="'Code'"
                                        v-bind:Fields="BaseFieldsAtt"
                                        v-bind:isRequired="this.isFieldRequired(formFieldsDictionary, 'doctorcode')"
                                        v-bind:isValid="this.isFieldValid(formFieldsDictionary, 'doctorcode')"
                                    />
                                </b-col>
                                <b-col lg="3" md="3" sm="12" v-if="this.isFieldVisible(formFieldsDictionary, 'privdoctorcode')">
                                    <MdLookup
                                        v-bind:Label="$t('Patient.ReferringDoctor')"
                                        v-bind:ModelCode="patient.privdoctorcode"
                                        v-bind:ModelDescription="ReferringDoctor.description"
                                        v-bind:RefCode="'ReferringDoctor'"
                                        v-bind:Api="'Doctors'"
                                        v-bind:FieldCode="'code'"
                                        v-bind:FieldDescription="'name'"
                                        :IsDisabled="this.isReadOnly"
                                        :SearchTitle="$t('Shared.Doctors')"
                                        :GetValues="onCodeConditionOk"
                                        :InvalidFeedback="$t('Patient.InvalidReferringDoctor')"
                                        :SearchFieldCode="'Code'"
                                        v-bind:Fields="BaseFieldsAtt"
                                        v-bind:isRequired="this.isFieldRequired(formFieldsDictionary, 'privdoctorcode')"
                                        v-bind:isValid="this.isFieldValid(formFieldsDictionary, 'privdoctorcode')"
                                    />
                                </b-col>
                                <b-col lg="3" md="3" sm="12" v-if="this.isFieldVisible(formFieldsDictionary, 'facilitycode')">
                                    <MdLookup
                                        v-bind:Label="$t('Patient.ServiceLocation')"
                                        v-bind:ModelCode="patient.facilitycode"
                                        v-bind:ModelDescription="ServiceLocation.description"
                                        v-bind:RefCode="'ServiceLocation'"
                                        v-bind:Api="'Facilities'"
                                        v-bind:FieldCode="'code'"
                                        v-bind:FieldDescription="'company'"
                                        :IsDisabled="this.isReadOnly"
                                        :SearchTitle="$t('Patient.ServiceLocation')"
                                        :GetValues="onCodeConditionOk"
                                        :InvalidFeedback="$t('Patient.InvalidServiceLocation')"
                                        :SearchFieldCode="'Code'"
                                        v-bind:Fields="BaseFieldsServ"
                                        v-bind:isRequired="this.isFieldRequired(formFieldsDictionary, 'facilitycode')"
                                        v-bind:isValid="this.isFieldValid(formFieldsDictionary, 'facilitycode')"
                                    />
                                </b-col>                    
                            </b-row>
                        </template>
                    </div>
                </div>
            </div>
        </div>

       <div class="space-actions"></div>
        <div class="page-actions">
            <MdButton
                v-bind:Label="$t('Shared.Back')"
                v-bind:ClassProp="this.editMode ? 'secondary mx-2 hidden':'secondary mx-2 btn-login'"
                v-on:click="goPatientList"
            />
            <MdButton
                v-bind:Label="$t('Patient.PrintWristband')"
                v-bind:ClassProp="(this.isReadOnly)?'primary mx-2':'primary btn-login mx-2'"
                v-on:click="PrintWristband"
                v-bind:Name="'btn_save_printwristband'"
            />
            <MdButton
                v-bind:Label="$t('Shared.Save')"
                v-bind:ClassProp="(this.isReadOnly)?'primary mx-2':'primary btn-login mx-2'"
                v-on:click="Save"
                v-bind:isReadOnly=!this.saveButtonEnabled
                v-bind:Name="'btn_save_patient'"
            />
        </div>

        <MdPasswordDlg v-if="VisibleSupervisorModal"
            v-bind:Type="'SuperVisor'"
            v-bind:VerificationType="'SupervisorPassword'"
            @getModalPassword="onModalPasswordResult($event)"
        />

        <PrintWristbandRep v-if="isReportVisible"
            :closeWindow="closeParamRepWindow"
            :PatientCode="this.$route.params.id"
            :ReportTitle="$t('Patient.LabelsReport')"

        />
    </div>
</template>

<script>

import moment from 'moment'
import PatientService from '@/services/patient.service'
import EnumService from '@/services/enum.service'
import Utils from '../../../common/utils'
import ModalService from '@/services/modal.service'
import ShowMessage from '@/components/messages/ShowMessage.js'
import DBFunctions from '@/common/DBFunctions.js'
import { EventBus } from '@/event-bus.js';
import GlobalService from '@/services/global.service'
import ProviderService from '@/services/provider.service'
import Permission from '@/common/Permission'
import BranchLocation from '@/services/branchlocation.service'
import RegionService from '@/services/region.service'
import AreaService from '@/services/area.service'
import CitiesService from '@/services/cities.service'
import LetterTemplatesService from '@/services/lettertemplates.service'

//let elemSaveBtn = '';
// MAPPING:  DDBB FieldKey(Case-Sensitive) -> Vue Property
const VUE_PROPERTY_EXCEPTIONS = {
    'firstName': 'firstname',
    'lastName': 'lastname',
    'area':'homeaddressarea'
}
export default {
    //components: { Multiselect },

  mixins: [ShowMessage, DBFunctions, Permission],
  name: 'PatientUAE',
  props: ["editMode","HaveChanges"],
  data() {
    return {
        dsFormConfiguration:[],
        isReportVisible: false,
        UseBlankDoctorCode:false,
        IsVip:false,
        IsSpecialCase:false,
        TitleWindow:"",
        formattedCurrencyValue: "$ 0.00",
        formattedCurrencyValue1: "$ 0.00",
         IsClinical:false,
        CountSave:0,
        RegistrationInfo:{},
        patientZipChanged:false,
        patientLegalZipChanged:false,
        lookupFieldChanged:false,
         fields: [
        { key: 'show_details', sortable: true},
        { key: 'programName', sortable: true, label: this.$tc('Shared.Program'), class: 'text-rigth' },
        { key: 'code', sortable: true, label: this.$t('Shared.Code'), class: 'hidden' },
        { key: 'dateFrom', sortable: true, label: this.$t('Shared.datefrom'), class: 'text-rigth' },
        { key: 'dateTo', sortable: true, label: this.$t('Shared.dateTo'), class: 'text-rigth' },
        ],
        pageOptions: [5, 10, 15 ],
        totalRows: 0,
        currentPage: 1,
        perPage: 10,
        filterOn: [],
        items: [],
        refTable: 'selectableTable',
        ShowMessageIsEmpty: true,

        Loading:true,
        BranchLocationList:[],
        shippingData:[],
        IdTypeList:EnumService.PatientIdTypes,
        CountryRecId:null,
        EmirateRecId:null,
        AreaRecId:null,
        PreferredLangList:[],
        MajorReligionList:[],

        AreaList:[],
        CountryOfOriginList:[],
        EmirateList:[],
        CityList:[],
        CountryOfResidenceList:[],
        EducationLevelList:EnumService.EducationLevel,
        lookupResult:[],
        modalMessage:'',
        pendingChanges:this.HaveChanges,
        PatientTitle:{
            programName:'',
            fullName:'',
            admitDate:'',
            dischargeDate:'',
            dob:'',
            activitytypename:'',
            startdatetime:'',
            ageFormatted:''
        },
        InfoPatient:{
            Dob:'',
            FirstName:'',
            LastName:'',
            Sex:'',
            Age:'',
            Title:'',
            SexExtend:'',
            Email:'',
            CellPhone:''

        },
        //permission:[],
        //Menu : this.$store.state.leftMenu,
       OptionsRightMenu:{
            visible:true,
            ItemsList:[],
            btnvisible:true,
            itemdisabled: false,
            PatientCode:''
        },
        ResourceParameter:'',
        TypeOption:"",
        edit_mode: this.editMode,
        CountryModel:{code:"",name:""},
        StateModel:{code:"",name:""},
        EthnicityModel:{code:"",name:""},
        AreaModel:{code:"",name:""},
        CityModel:{code:"",name:""},
        EmployModel:{value:"",text:""},
        BranchLocationModel:{code:"",description:""},
        VisibleSupervisorModal:false,
        AllowEmptyUAEID:false,
        RequiredUAEID:true,
        ReadOnlyIfAllowEmpty:false,

        patient:{
            AllowEmptyUAEID:false,
            fullMiddleName:'',
            branchLocationPrefix:"",
            branchLocation:"",
            accState: '',
            isVIP:false,
            acceptAssign: '',
            middleNameAR:"",
            address1: '',
            address2: '',
            familyName:"",
            familyNameAR:'',
            autho: '',
            billToCompany: '',
            billfortrans: '',
            firstNameAR:'',
            branch: '',
            city: "",
            companyAddress1: '',
            fourthNameAR:"",
            companyAddress2: '',
            companyCity: '',
            companyContact: '',
            companyCountry: '',
            companyFax: '',
            companyName: '',
            companyPhone: '',
            companyState: '',
            night_phone_relation:'',
            cellphone_relation:'',
            thirdname:'',
            companyZip: "",
            consultDate: null,
            country: "",
            dateDeceased: null,
            dayPhone: '',
            deceased: '',
            dob: null,
            doctorcode: '',
            emergency: '',
            employed: '',
            employeecode: '',
            enablerepeat: '',
            ethcode: '',
            facilitycode: '',
            facilityDescription: '',
            firstname: '',
            formSigned: '',
            height1: null,
            height2: null,
            infoRelease: '',
            initial: "",
            injuryDate: null,
            lastname: '',
            legalAddress1: '',
            legalAddress2: '',
            legalCity: '',
            legalContact: '',
            legalCountry: '',
            legalFax: '',
            legalFirstname: '',
            legalLastname: '',
            legalPhone: '',
            cellphone_countrycode:'',
            day_phone_countrycode:'',
            legalRep: '',
            legalState: '',
            day_phone_relation:'',
            legalZip: '',
            married: '',
            medigapRelease: '',
            military: '',
            nightPhone: '',
            patientid: '',
            patientsignature: "",
            primaryins: '',
            privdoctorcode: '',
            referal: '',
            relatedToAuto: '',
            relatedToEmp: '',
            relatedToOther: '',
            retireddate: null,
            returnWork: null,
            sex: '',
            sgDate: null,
            ssn: '',
            state: '',
            student: '',
            lastNameAR:'',
            night_phone_countrycode:'',
            suffix: '',
            title: '' ,
            validity: null,
            weight1: null,
            weight2: null,
            zip: '',
            notActive: '',
            referalTo: '',
            espdt: '',
            epsdt: '',
            sysDate: moment().format('YYYY-MM-DD'),
            sysUser: '',
            familyIncome: '',
            majorLanguage: '',
            majorReligion: '',
            disability: '',
            importId: '',
            fourthName:'',
            uaeid_expdate:null,
            homeaddressarea:"",
            email: '',
            cellPhone: '',
            cellCompany: '',
            textAddress: '',
            deathReason: '',
            ethnicityCode:"",
            commPreference: '',
            isCriminal: '',
            financialSupport: '',
            educationLevel: '',
            isVoluntary: '',
            isAdmitted: '',
            icd9: '',
            previousFirstName: '',
            previousLastName: '',
            previousInitial: '',
            ethcodeGranularity: null,
            majorLanguageAbility: '',
            teamCode: '',
            isExpat: '',
            county: '',
            township: '',
            maidenName: '',
            homeless: '',
            femaleHeadHousehold: '',
            ivuse: '',
            militaryHistory: '',
            vacoverage: '',
            numberDependents: null,
            legalStatus: '',
            educationStatus: '',
            personalIncome: '',
            personalIncomeAmt: null,
            familyIncomeAmt: null,
            ctnPatientId: '',
            eyeColor: '',
            hairColor: '',
            gender: '',
            pptoken: '',
            pptokenSysDate: null,
            nickname: '',
            employeddesc: '',
        },
        id: null,
        ReferralFrom:{  "description": ''  },
        ReferralTo:{ "description": '' },
        AttendingDoctor:{ "description": '' },
        ReferringDoctor:{ "description": '' },
        ServiceLocation:{ "description": '' },
        CaseManager:{ "description": '' },
        title_list: EnumService.Titles,
        sex_list: EnumService.Sexs,
        marital_status_list: EnumService.MaritalStatusUAE,
        employment_list: EnumService.EmploymentUAE,
        student_list: EnumService.Student,
        inactive_recods_list: EnumService.YesNoOptionsInverted,
        YesNoOptions: EnumService.YesNoOptions,

        gender_list: EnumService.SexsMaleFemaleOnly,
        ethnicity_list: [],
        race_list: [],
        eye_color_list: [],
        hair_color_list: [],
        comm_preference_list: [],
        family_income_list: [],
        personal_income_list: [],
        major_language_list: [],
        major_language_ability_list: [],
        major_religion_list: [],
        disability_list: [],
        legal_status_list: [],
        education_status_list: [],
        RelationList:EnumService.Relations,

        FieldsParameter : [],
        acceptAssign_list: EnumService.AcceptAssign,
        infoRelease_list: EnumService.InfoRelease,
        modelBillToCompany:[],
        value: '',
        formatted: '',
        selected: '',
        isReferralFromValid: true,
        isReferralToValid: true,
        isAttendingDoctorValid: true,
        isReferringDoctorValid: true,
        isServiceLocationValid: true,
        isCaseManagerValid: true,


        isUAEIDValid:true,

        isReadOnly: false,
        fieldCode: '',
        fieldDescription: '',
        tablist: [
            { title: this.$t('Shared.General'), link: '#contentGeneral', active: true},
            { title: this.$t('Shared.Additional'), link: '#contentAdditional'},
           /* { title: this.$t('Patient.TabCurrentTreatmentInfo'), link: '#contentCurrentTreatmentInfo'},
            { title: this.$t('Patient.TabBillingFlags'), link: '#cotentBillingFlags'}*/
        ],
        tablist2: [
            /*{ title: 'Diag 1-4', link: '#contentDiagnosis1_4', active: true},
            { title: 'Diag 5-8', link: '#contentDiagnosis5_8'},
            { title: 'Diag 9-12', link: '#contentDiagnosis9_12'},
            { title: 'Diag 13-16', link: '#contentDiagnosis13_16'},
			{ title: 'Cond 1-4', link: '#contentCondition1_4',active: true},
			{ title: 'Cond 5-7', link: '#contentCondition5_7'},*/
        ],
        //eslint-disable-next-line
        reg: /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/,
       // pendingChanges: false,
        emailValid: false,
        age: '',
        CaseManagerFields:[
            { key: 'name', sortable: true, label: this.$t('Shared.FirstName') },
            { key: 'code', sortable: true, label: this.$t('Shared.Code')},
            { key: 'employeeType', sortable: true, label: this.$t('employeeType.EmplTypeTitle')},
            { key: 'cellPhone', sortable: true, label: this.$t('Shared.CellPhone')},
            { key: 'email', sortable: true, label: this.$t('Shared.Email')},
            { key: 'credentials', sortable: true, label: this.$t('employee.Credentials')}

            /*{ key: 'name', sortable: true, label: 'Name' },
            { key: 'code', sortable: true, label: 'Code' },
            { key: 'employeeType', sortable: true, label: 'Employee Type' },
            { key: 'employeeTypeCode', sortable: true, label: 'Employee Type Code' },
            { key: 'employeeId', sortable: true, label: 'Employee Id' },
            { key: 'cellPhone', sortable: true, label: 'CellPhone' },
            { key: 'dayphone', sortable: true, label: 'DayPhone' },
            { key: 'nightphone', sortable: true, label: 'NightPhone' },
            { key: 'fax', sortable: true, label: 'Fax' },
            { key: 'textAddress', sortable: true, label: 'Text Address' },
            { key: 'eMail', sortable: true, label: 'EMail' },
            { key: 'credentials', sortable: true, label: 'Credentials' },
            { key: 'license', sortable: true, label: 'License' },
            { key: 'npi', sortable: true, label: 'NPI' },
            { key: 'address1', sortable: true, label: 'Address1' },
            { key: 'address2', sortable: true, label: 'Address2' },
            { key: 'city', sortable: true, label: 'City' },
            { key: 'zip', sortable: true, label: 'Zip' },
            { key: 'state', sortable: true, label: 'State' },
            { key: 'userid', sortable: true, label: 'User Id' }*/
        ],
        autoAssignCode:true,
        isAutoAssignCodeValid:true,
        currentAppointmentDB:{
            guid:'',
            activitytypecode:'',
            employee:{
                firstname:"",
                lastname:""
            }
        },
        BaseFieldsAtt:[
            { key: 'name', sortable: true, label: this.$t('Shared.FirstName') },
            { key: 'code', sortable: true, label: this.$t('Shared.Code')},
            { key: 'npi', sortable: true, label: this.$t('Shared.NPI')},
            { key: 'phone', sortable: true, label: this.$t('Shared.Phone')},
            { key: 'email', sortable: true, label: this.$t('Shared.Email')},
            { key: 'credentials', sortable: true, label: this.$t('employee.Credentials')}
        ],
        BaseFieldsServ:[
            { key: 'company', sortable: true, label: this.$t('employee.Company') },
            { key: 'contact', sortable: true, label: this.$tc('Contact.Contact') },
            { key: 'code', sortable: true, label: this.$t('Shared.Code')},
            { key: 'providerId', sortable: true, label: this.$t('Shared.ProviderId')},
            { key: 'phone', sortable: true, label: this.$t('Shared.Phone')},
            { key: 'address1', sortable: true, label: this.$t('Shared.Address1')},
            { key: 'city', sortable: true, label: this.$t('Shared.City')},
            { key: 'zip', sortable: true, label: this.$t('Shared.Zip')},
            { key: 'state', sortable: true, label: this.$t('Shared.State')}
        ],
        BaseFieldsReferido:[
            { key: 'name', sortable: true, label: this.$t('Shared.Name') },
            { key: 'code', sortable: true, label: this.$t('Shared.Code')},
            { key: 'contact', sortable: true, label: this.$tc('Contact.Contact') },
            { key: 'phone', sortable: true, label: this.$t('Shared.Phone')},
            { key: 'address1', sortable: true, label: this.$t('Shared.Address1')},
            { key: 'city', sortable: true, label: this.$t('Shared.City')},
            { key: 'zip', sortable: true, label: this.$t('Shared.Zip')},
            { key: 'state', sortable: true, label: this.$t('Shared.State')}
        ],
        unitSys: 'U',
        hasPatientWristbandSetup: false,
        wasSaved: false
  }
 },
    computed: {
        formFieldsDictionary() {
            if (!this.dsFormConfiguration || !Array.isArray(this.dsFormConfiguration)) {
                return {};
            }

            return this.dsFormConfiguration.reduce((acc, field) => {
                acc[field.fieldKey] = field;
                return acc;
            }, {});
        },
        isContactInfoSectionVisible() {
            const billingFlagsFields = [
                'cellphone_countrycode', 'cellPhone', 'cellphone_relation',
                'day_phone_countrycode', 'dayPhone', 'day_phone_relation',
                'night_phone_countrycode', 'nightPhone', 'night_phone_relation',
                'email'
            ];

            return billingFlagsFields.some(key => this.isFieldVisible(this.formFieldsDictionary, key));
        },
        isAddressSectionVisible() {
            const billingFlagsFields = [
                'address1', 'country', 'state', 'area', 'city'
            ];

            return billingFlagsFields.some(key => this.isFieldVisible(this.formFieldsDictionary, key));
        },
        isGeneralSectionVisible() {
            const billingFlagsFields = [
                'sex', 'married', 'employed', 'employeddesc', 'educationLevel',
                'majorReligion', 'majorLanguage', 'ethnicityCode'
            ];

            return billingFlagsFields.some(key => this.isFieldVisible(this.formFieldsDictionary, key));
        },
        isAdditionalSectionVisible() {
            const billingFlagsFields = [
                'referal', 'referalTo', 'doctorcode', 'privdoctorcode', 'facilitycode'
            ];

            return billingFlagsFields.some(key => this.isFieldVisible(this.formFieldsDictionary, key));
        },

        referralFromState() {
            return this.isReferralFromValid ? null : false
        },

        referralToState() {
            return this.isReferralToValid ? null : false
        },

        attendingDoctorState() {
            return this.isAttendingDoctorValid ? null : false
        },

        referringDoctorState() {
            return this.isReferringDoctorValid ? null : false
        },

        serviceLocationState() {
            return this.isServiceLocationValid ? null : false
        },

        caseManagerState() {
            return this.isCaseManagerValid ? null : false
        },

        minHeightWeight() {
            return this.unitSys === 'U' ? '0' : '0.00';
        },

        stepHeightWeight() {
            return this.unitSys === 'U' ? '1' : '0.1';
        },
        saveButtonEnabled() {
            return !this.isReadOnly && this.pendingChanges;
        }
    },

    methods : {

        getPosition(list, model, field = 'value') {
            if (!model || !list || !list.length) {
                return -1;
            }

            // Model es objeto
            if (typeof model === 'object') {
                return list.findIndex(x => x[field] === model[field]);
            }

            // Model es string, number, etc.
            return list.findIndex(x => x[field] === model);
        },

        PrintWristband() {
            this.isReportVisible = true
        },

        closeParamRepWindow() {
            this.isReportVisible = false
        },

        label(value) {
            if (value === 'Weightlbs') {
                return this.unitSys === 'U' ? ' (lb)' :  ' (kg)';
            }

            if (value === 'WeightOz') {
                return this.unitSys === 'U' ? ' (Oz)' :  ' (g)';
            }

            if (value === 'Heightft' || value === 'HeadCirin') {
                return this.unitSys === 'U' ? ' (ft)' :  ' (cm)';
            }

            if (value === 'HeightInc') {
                return this.unitSys === 'U' ? ' (in)' :  ' (mm)';
            }

            return '';
        },

        onChangeAllowEmpty(empty){
            this.AllowEmptyUAEID = empty;

            if(this.AllowEmptyUAEID){
                this.VisibleSupervisorModal = true;
            }else{
                this.patient.AllowEmptyUAEID = false;
                this.ReadOnlyIfAllowEmpty = false;
            }
        },

        onModalPasswordResult(result){
            if(result.Event === 'Ok'){
                if(result.status === true) {
                    this.ReadOnlyIfAllowEmpty = true;
                    this.patient.AllowEmptyUAEID = true;
                    this.patient.patientid = "";
                    this.patient.uaeid_expdate = null;
                    this.RequiredUAEID = false;
                }else{
                    this.patient.AllowEmptyUAEID = false;
                    this.RequiredUAEID = true;
                    this.ReadOnlyIfAllowEmpty = false;
                    this.AllowEmptyUAEID = false;
                    this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.InvalidSupervisorPass'),"error");
                }
            }

            if(result.Event === 'Cancel'){
                this.AllowEmptyUAEID = false;
                this.RequiredUAEID = true;
                this.isUAEIDValid = !this.RequiredUAEID;
                this.patient.AllowEmptyUAEID = false;
            }

            this.VisibleSupervisorModal = false;

        },

        ChangeDropDownTitle(obj){
            this.patient.title = obj ? obj.value : '';
        },

        ChangeExpiryDate(){

        },

        ChangeDropDownRelationShip1(item){
            this.patient.day_phone_relation = item ? item.value : "";
        },

        ChangeDropDownRelationShip2(item){
            this.patient.night_phone_relation = item ? item.value : "";
        },

        ChangeDropDownRelationShip3(item){
            this.patient.cellphone_relation = item ? item.value : "";
        },

        ChangeDropDownArea(item){
            this.AreaModel = item ? item : {code:"",name:""};
            this.patient.homeaddressarea = item ? item.name : "";
            this.CityList = [];
            this.AreaRecId = item.recId;
            this.getCityByArea();
        },

        ChangeDropDownCity(item){
            this.CityModel = item ? item : {code:"",name:""};
            this.patient.city = item ?  item.name :"";
        },

        ChangeDropDownCountryOfOrigin(item){
           this.EthnicityModel = item ? item : {code:"",name:""};
           this.patient.ethnicityCode = this.EthnicityModel.code;
        },

        ChangeDropDownMaritalStatus(item){
            this.patient.married = item ? item.value : "";
        },

        ChangeDropDownLevel(item){
            this.patient.educationLevel = item ? item.value : "";
        },

        ChangeAcceptedDate(){

        },

        ChangeDropDownPreferredLan(item){
            this.patient.majorLanguage = item ? item.code:"";
        },

         ChangeDropDownMajorReligion(value){
            this.patient.majorReligion = value ? value.code : '';
        },

        ChangeDropDownBranchLocation(item){
            this.BranchLocationModel =  item ? item : {code:"",description:""};
            this.patient.branchLocation = this.BranchLocationModel.code;
            if(item && item.code){
                 this.getBranchById(item.code);
            }else{
                this.patient.branchLocationPrefix = "";
            }
        },

        ChangeDropDownEmirate(item){
            this.StateModel = item ? item : {code:"",name:""};
            this.patient.state = this.StateModel.name;
            this.EmirateRecId = item.recId;
            this.AreaList = [];
            this.getAreaByEmirate();
        },

        ChangeDropDownGender(item){
            this.patient.sex = item ? item.value : '';
        },
        ChangeDropDownEthnicity(item){
            this.EthnicityModel = item ? item : {code:"",name:""};
            this.patient.ethnicityCode = this.EthnicityModel.code;
        },
        ChangeDropDownRace(value){
            this.patient.ethcode = value ? value.code : '';
        },
        ChangeDropDownEyeColor(value){

            this.patient.eyeColor = value ? value.code : '';
        },
        ChangeDropDownHairColor(value){
            this.patient.hairColor = value ? value.code : '';
        },
        ChangeDropDownMarried(value){
            this.patient.married = value ? value.value : '';
        },
        ChangeDropDownEmployment(value){
            this.EmployModel = value ? value : {value:"",text:""};
            this.patient.employed = value ? value.value : '';
        },
        ChangeDropDownStudent(value){
            this.patient.student = value ? value.value : '';
        },
        ChangeDropDownCommPreference(value){
            this.patient.commPreference = value ? value.code : '';
        },
        ChangeDropDownFamilyIncome(value){

            this.patient.familyIncome = value ? value.code : '';

            if(this.patient.familyIncome!="OTHER"){
                this.patient.familyIncomeAmt = "";
                this.formattedCurrencyValue = "$ 0.00";
                this.focusOut();
            }
        },
        ChangeDropDownPersonalIncome(value){
            this.patient.personalIncome = value ? value.code : '';

            if(this.patient.personalIncome!="OTHER"){
                this.patient.personalIncomeAmt = "";
                this.formattedCurrencyValue1 = "$ 0.00";
                this.focusOut1();
            }
        },
        ChangeDropDownMajorLanguage(value){
            this.patient.majorLanguage = value ? value.code : '';
        },
        ChangeDropDownMajorLanguageAbility(value){
            this.patient.majorLanguageAbility = value ? value.code : '';
        },

        ChangeDropDownDisability(value){
            this.patient.disability = value ? value.code : '';
        },
        ChangeDropDownLegalStatus(value){
            this.patient.legalStatus = value ? value.code : '';
        },
        ChangeDropDownEducationStatus(value){
            this.patient.educationStatus = value ? value.code : '';
        },
        ChangeDropDownInfoRelease(value){
            this.patient.infoRelease = value ? value.value : '';
        },
        ChangeDropDownAcceptAssign(value){
            this.patient.acceptAssign = value ? value.value : '';
        },

        ChangeDropDownCountryOfResidence(item){
            this.CountryModel = item ? item : {code:"",name:""};
            this.patient.country = this.CountryModel.name;
            this.CountryRecId = item ? item.recId : null;
            this.EmirateList = [];
            this.getEmiratebyCountry();
        },

        getBranchById(code){
            this.$emit('load', true);
            BranchLocation.GetBranchLocation(code)
            .then((response) => {
                if(response.status == '200'){
                    this.patient.branchLocationPrefix = response.data.patientPrefix;
                }
                this.$emit('load', false);
            })
            .catch(error => {
                this.$emit('load', false);
                  if (error.response) {
                     this.showMessage(this.$tc('Msg.Error'),error,"error");
                  }
            });
        },

        pageChanged(page) {
            this.currentPage = page;
        },

        ChangeDropDownIdType(item) {
            this.patient.branch = item ? item.text : "";
        },

        PerPageFunction(perpage) {
            this.perPage = perpage;


        },
        onRowSelected(items) {
            this.selected = items
        },

        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },

        getOnlyNameInArrCountry(arr) {
            let temp = [];
            arr.forEach(element => {
                temp.push({ code: element.code, name: element.country });
            });
            return temp;
        },


        getRecIdByCountry(arr, country) {
            let RecId = "";
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].name && arr[i].name.toLowerCase() === country.toLowerCase()) {
                    RecId = arr[i].recId;
                    break;
                }
            }
            return RecId;
        },

        getAreaByEmirate() {
            this.$emit('load', true);
            AreaService.getAreas({ EmirateRecId: this.EmirateRecId })
                .then((response) => {
                    if (response.status == '200') {
                        this.$emit('load', false);
                        this.AreaList = this.getOnlyCountry(response.data);
                        this.$store.commit('initAreaList')
                        this.$store.commit('setareawasloaded', true);
                        response.data.forEach(element => {
                            this.$store.commit('setAreaList', element);
                        });
                    }
                    this.$emit('load', false);
                })
                .catch((error) => {
                    this.$emit('load', false);
                    if (error.response) {
                        this.showMessage(this.$tc('Msg.Error'), error, "error");
                    }
                });
        },

        getCityByArea() {
            CitiesService.getCities({ AreaRecId: this.AreaRecId })
                .then((response) => {
                    if (response.status == '200') {
                        this.CityList = this.getOnlyCountry(response.data);
                        this.$store.commit('initCitiesList')
                        this.$store.commit('setcitieswasloaded', true);
                        response.data.forEach(element => {
                            this.$store.commit('setCitiesList', element);
                        });
                    }
                })
                .catch((error) => {
                    if (error.response) {
                        this.showMessage(this.$tc('Msg.Error'), error, "error");
                    }
                });
        },

        getOnlyCountry(arr) {
            let temp = [];
            arr.forEach(element => {
                temp.push({ code: element.name, name: element.name, recId: element.recId });
            });
            return temp;
        },

        async populateSelects() {

            // Combined UAE lookup: Countries of Residence/Origin, Branch Locations, Ethnicities,
            // Races, Eye/Hair Colors, Communication Preferences, Incomes, Languages, Religion,
            // Legal Status, Disability and Education Status all come from the same endpoint,
            // so if one of them was already loaded in the store, all of them were.
            if (this.$store.state.countrywasloaded) {
                this.CountryOfResidenceList = this.getOnlyCountry(this.$store.state.CountryList);
                this.CountryRecId = this.getRecIdByCountry(this.CountryOfResidenceList, this.$store.state.companies.Country);

                this.CountryOfOriginList = this.getOnlyNameInArrCountry(this.$store.state.MdCountriesList);

                if (!this.edit_mode) {
                    this.CountryModel.code = this.getCodeByCountry(this.CountryOfOriginList, this.$store.state.companies.Country);
                    this.CountryModel.name = this.$store.state.companies.Country;
                    this.patient.country = this.CountryModel.code;

                    this.EthnicityModel.code = this.getCodeByCountry(this.CountryOfOriginList, this.$store.state.companies.Country);
                    this.EthnicityModel.name = this.$store.state.companies.Country;
                    this.patient.ethnicityCode = this.EthnicityModel.code;
                }

                this.BranchLocationList = this.$store.state.branchlocationsList;
                this.ethnicity_list = this.$store.state.ethnicityList;
                this.race_list = this.$store.state.raceList;
                this.eye_color_list = this.$store.state.eyeColorList;
                this.hair_color_list = this.$store.state.hairColorList;
                this.comm_preference_list = this.$store.state.commPreferenceList;
                this.family_income_list = this.$store.state.familyIncomeList;
                this.personal_income_list = this.$store.state.personalIncomeList;
                this.PreferredLangList = this.$store.state.majorLanguageList;
                this.major_language_ability_list = this.$store.state.majorLanguageAbilityList;
                this.MajorReligionList = this.$store.state.majorReligionList;
                this.disability_list = this.$store.state.disabilityList;
                this.legal_status_list = this.$store.state.legalStatusList;
                this.education_status_list = this.$store.state.educationStatusList;
            } else {
                await PatientService.getPatientUAELookUp()
                    .then((response) => {
                        if (response.status == '200') {
                            const data = response.data;

                            this.CountryOfResidenceList = this.getOnlyCountry(data.countriesOfResidence);
                            this.CountryRecId = this.getRecIdByCountry(this.CountryOfResidenceList, this.$store.state.companies.Country);
                            this.$store.commit('initCountryList')
                            this.$store.commit('setcountrywasloaded', true);
                            data.countriesOfResidence.forEach(element => {
                                this.$store.commit('setCountryList', element);
                            });

                            this.CountryOfOriginList = this.getOnlyNameInArrCountry(data.countriesOfOrigin);
                            if (!this.edit_mode) {
                                this.EthnicityModel.code = this.getCodeByCountry(this.CountryOfOriginList, this.$store.state.companies.Country);
                                this.EthnicityModel.name = this.$store.state.companies.Country;
                                this.patient.ethnicityCode = this.EthnicityModel.code;
                            }
                            this.$store.commit('initMdCountriesList')
                            this.$store.commit('setmdCountrieswasloaded', true);
                            data.countriesOfOrigin.forEach(element => {
                                this.$store.commit('setMdCountriesList', element);
                            });

                            this.BranchLocationList = data.branchLocations;
                            this.$store.commit('initBranchLocationList')
                            this.$store.commit('setBranchLocationwasloaded', true);
                            data.branchLocations.forEach(element => {
                                this.$store.commit('setBranchLocationList', element);
                            });

                            this.ethnicity_list = data.ethnicities;
                            this.$store.commit('initEthnicityList');
                            this.$store.commit('setethnicitywasloaded', true);
                            data.ethnicities.forEach(element => {
                                this.$store.commit('setEthnicityList', element);
                            });

                            this.race_list = data.races;
                            this.$store.commit('initRaceList');
                            this.$store.commit('setracewasloaded', true);
                            data.races.forEach(element => {
                                this.$store.commit('setRaceList', element);
                            });

                            this.eye_color_list = data.eyeColors;
                            this.$store.commit('initEyeColorList');
                            this.$store.commit('seteyeColorwasloaded', true);
                            data.eyeColors.forEach(element => {
                                this.$store.commit('setEyeColorList', element);
                            });

                            this.hair_color_list = data.hairColors;
                            this.$store.commit('initHairColorList');
                            this.$store.commit('sethairColorwasloaded', true);
                            data.hairColors.forEach(element => {
                                this.$store.commit('setHairColorList', element);
                            });

                            this.comm_preference_list = data.communicationPreferences;
                            this.$store.commit('initCommPreferenceList');
                            this.$store.commit('setcommPreferencewasloaded', true);
                            data.communicationPreferences.forEach(element => {
                                this.$store.commit('setCommPreferenceList', element);
                            });

                            this.family_income_list = data.familyIncomes;
                            this.$store.commit('initFamilyIncomeList');
                            this.$store.commit('setfamilyIncomewasloaded', true);
                            data.familyIncomes.forEach(element => {
                                this.$store.commit('setFamilyIncomeList', element);
                            });

                            this.personal_income_list = data.personalIncomes;
                            this.$store.commit('initPersonalIncomeList');
                            this.$store.commit('setpersonalIncomewasloaded', true);
                            data.personalIncomes.forEach(element => {
                                this.$store.commit('setPersonalIncomeList', element);
                            });

                            this.PreferredLangList = data.majorLanguages;
                            this.$store.commit('initMajorLanguageList');
                            this.$store.commit('setmajorLanguagewasloaded', true);
                            data.majorLanguages.forEach(element => {
                                this.$store.commit('setMajorLanguageList', element);
                            });

                            this.major_language_ability_list = data.languageAbilityModes;
                            this.$store.commit('initMajorLanguageAbilityList');
                            this.$store.commit('setmajorLanguageAbilitywasloaded', true);
                            data.languageAbilityModes.forEach(element => {
                                this.$store.commit('setMajorLanguageAbilityList', element);
                            });

                            this.MajorReligionList = data.majorReligions;
                            this.$store.commit('initMajorReligionList');
                            this.$store.commit('setmajorReligionwasloaded', true);
                            data.majorReligions.forEach(element => {
                                this.$store.commit('setMajorReligionList', element);
                            });

                            this.disability_list = data.disabilities;
                            this.$store.commit('initDisabilityList');
                            this.$store.commit('setdisabilitywasloaded', true);
                            data.disabilities.forEach(element => {
                                this.$store.commit('setDisabilityList', element);
                            });

                            this.legal_status_list = data.legalStatuses;
                            this.$store.commit('initLegalStatusList');
                            this.$store.commit('setlegalStatuswasloaded', true);
                            data.legalStatuses.forEach(element => {
                                this.$store.commit('setLegalStatusList', element);
                            });

                            this.education_status_list = data.educationStatuses;
                            this.$store.commit('initEducationStatusList');
                            this.$store.commit('seteducationStatuswasloaded', true);
                            data.educationStatuses.forEach(element => {
                                this.$store.commit('setEducationStatusList', element);
                            });
                        }
                    })
                    .catch((error) => {
                        if (error.response) {
                            this.showMessage(this.$tc('Msg.Error'), error, "error");
                        }
                    });
            }

            // Emirate
            if (this.$store.state.regionwasloaded) {
                this.EmirateList = this.getOnlyCountry(this.$store.state.RegionList);
            } else {
                await RegionService.getRegions({ CountryRecId: this.CountryRecId })
                    .then((response) => {
                        if (response.status == '200') {
                            this.EmirateList = this.getOnlyCountry(response.data);
                            this.$store.commit('initRegionList')
                            this.$store.commit('setregionwasloaded', true);
                            response.data.forEach(element => {
                                this.$store.commit('setRegionList', element);
                            });
                        }
                    })
                    .catch((error) => {
                        if (error.response) {
                            this.showMessage(this.$tc('Msg.Error'), error, "error");
                        }
                    });
            }

            // Area
            if (this.$store.state.areawasloaded) {
                this.AreaList = this.getOnlyCountry(this.$store.state.AreaList);
            } else {
                AreaService.getAreas({ EmirateRecId: this.EmirateRecId })
                    .then((response) => {
                        if (response.status == '200') {
                            this.AreaList = this.getOnlyCountry(response.data);
                            this.$store.commit('initAreaList')
                            this.$store.commit('setareawasloaded', true);
                            response.data.forEach(element => {
                                this.$store.commit('setAreaList', element);
                            });
                        }
                    })
                    .catch((error) => {
                        if (error.response) {
                            this.showMessage(this.$tc('Msg.Error'), error, "error");
                        }
                    });
            }

            // City
            if (this.$store.state.citieswasloaded) {
                this.CityList = this.getOnlyCountry(this.$store.state.CitiesList);
            } else {
                CitiesService.getCities({ AreaRecId: null })
                    .then((response) => {
                        if (response.status == '200') {
                            this.CityList = this.getOnlyCountry(response.data);
                            this.$store.commit('initCitiesList')
                            this.$store.commit('setcitieswasloaded', true);
                            response.data.forEach(element => {
                                this.$store.commit('setCitiesList', element);
                            });
                        }
                    })
                    .catch((error) => {
                        if (error.response) {
                            this.showMessage(this.$tc('Msg.Error'), error, "error");
                        }
                    });
            }

            /* if(this.$store.state.genderwasloaded){
                 this.gender_list = this.$store.state.genderList;
             }else{
                 GlobalService.getGender()
                 .then((response) => {
                      if(response.status == '200'){
                       this.gender_list = response.data;
                       this.$store.commit('initGenderList')
                       this.$store.commit('setGenderwasloaded',true);
                       response.data.forEach(element => {
                         this.$store.commit('setGenderList',element);
                       });
                      }
               })
                .catch((error) => {
                    if (error.response) {
                      this.showMessage(this.$tc('Msg.Error'),error,"error");
                     }
                });
             } */

            if (!this.edit_mode) {
                if (this.$store.state.companies.isUAE) {
                    this.patient.day_phone_countrycode = "+971";
                    this.patient.night_phone_countrycode = "+971";
                    this.patient.cellphone_countrycode = "+971";
                }
            }
        },

        async getEmiratebyCountry() {
            this.$emit('load', true);
            await RegionService.getRegions({ CountryRecId: this.CountryRecId })
                .then((response) => {
                    if (response.status == '200') {
                        this.$emit('load', false);
                        this.EmirateList = this.getOnlyCountry(response.data);
                        this.$store.commit('initRegionList')
                        this.$store.commit('setregionwasloaded', true);
                        response.data.forEach(element => {
                            this.$store.commit('setRegionList', element);
                        });
                    }
                    this.$emit('load', false);
                })
                .catch((error) => {
                    this.$emit('load', false);
                    if (error.response) {
                        this.showMessage(this.$tc('Msg.Error'), error, "error");
                    }
                });
        },

        validate_required() {
            let dynamicFields = this.dsFormConfiguration.filter(
                field => field.fieldKey !== 'email' && field.fieldKey !== 'patientid' 
            );

            this.isUAEIDValid = true;

            if (!this.AllowEmptyUAEID) {
                this.isUAEIDValid = this.patient.patientid && this.patient.patientid.trim() != "" && this.patient.patientid.length > 0 ? true : false;
            }

            const dynamicFormValidation = this.validateDynamicRequired(dynamicFields, this.patient, VUE_PROPERTY_EXCEPTIONS);
            let isDynamicFormValid = dynamicFormValidation.isValid;
            
            return this.isUAEIDValid && isDynamicFormValid;
        },

        validate_entries() {
            const isEmailFieldVisible = this.isFieldVisible(this.formFieldsDictionary, 'email');
            const isDobFieldVisible = this.isFieldVisible(this.formFieldsDictionary, 'dob');
            let isDOBValid = true;
            let isEmailValid = true;

            if (isDobFieldVisible) {
                isDOBValid = (Utils.isNullOrEmptyString(this.patient.dob) || Utils.validateBirthDate(this.patient.dob));
            }
            

            if (isEmailFieldVisible) {
                isEmailValid = (this.patient.email == "" || this.patient.email == null) ? true : false;
                EventBus.$emit('onCheckValid', this.patient.email, "email", "input_patient_email", this.$t('Shared.Email'));
            }

            const result = (isDOBValid && isEmailValid);
            return result;
        },

        focusOut() {
            this.patient.familyIncomeAmt = this.formattedCurrencyValue ? parseFloat(this.formattedCurrencyValue.toString().replace(/[$,]/g, "")): null
            if (isNaN(this.patient.familyIncomeAmt)) {
                this.patient.familyIncomeAmt = 0
            }
            this.formattedCurrencyValue = this.formattedCurrencyValue ? "$ " + this.patient.familyIncomeAmt.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,"): null
        },

        focusIn() {
            this.formattedCurrencyValue = this.patient.familyIncomeAmt;
        },

        focusOut1() {
            this.patient.personalIncomeAmt = this.formattedCurrencyValue1 ? parseFloat(this.formattedCurrencyValue1.replace(/[$,]/g, "")): null
            if (isNaN(this.patient.personalIncomeAmt)) {
                this.patient.personalIncomeAmt = 0
            }
            this.formattedCurrencyValue1 = this.formattedCurrencyValue1 ? "$ " + this.patient.personalIncomeAmt.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,"): null
        },

        focusIn1() {
            this.formattedCurrencyValue1 = this.patient.personalIncomeAmt;
        },

        formatterDate(value){
            return Utils.formatterDate(value);
        },

        formatterDateToString(date){
            return Utils.formatterDateToString(date);
        },

        formatterStringToDate(stringDate){
            if(stringDate){
                var dateArray = stringDate.split("/");
                var dd= dateArray[1];
                var mm= "";
                if(dateArray[0].lenght == 1){
                    mm= "0"+dateArray[0];
                }else
                    mm= dateArray[0];
                var yyyy= dateArray[2];
                var newDate =  new Date(yyyy, mm, dd).toISOString();
                return newDate;
            }
        },

        EnabledItemRightMenu(){
            this.OptionsRightMenu.PatientCode = this.patient.patientcode;
            this.OptionsRightMenu.ItemsList = EnumService.PatientItems;
            this.OptionsRightMenu.visible = true;
            this.OptionsRightMenu.btnvisible = true;
            this.OptionsRightMenu.itemdisabled = false;
            let layoutStatus = this.$store.state.layoutStatus;
            switch(layoutStatus) {
                case 'L0R0':
                    this.$store.commit('setlayoutStatus', 'L0R1');
                break;
                default:
                    this.$store.commit('setlayoutStatus', 'L1R1');
            }
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
        },

        async UpdatePatient(){
              if(this.id == '' || this.id == null || this.id == undefined){
                 this.id = this.patient.patientcode;
             }
            await PatientService.update( this.id, this.patient)
             .then((response) => {
                 if(response.status == '200' && response.data){
                        this.wasSaved = true;
                        this.pendingChanges = false;
                      this.PupulateInfoHeaderRightMenu();
                      this.EmitEventInfoHeaderRightMenu();
                      this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                         title: this.$t('Msg.Success'),
                          autoHideDelay: 5000,
                          variant: "success"
                      })

                      this.getPatient(this.id);
                      this.GetPatientByCode();
                      EventBus.$emit('UpdateMarqueeRightBar',null);
                 }
                  this.$emit('load', false);
             })
            .catch((error) => {
                  this.showResponseErrorMessage(error);
                 this.$route.router.go('/');
            });
        },

        async InsertPatient() {
            await PatientService.addPatient(this.patient)
                .then((response) => {
                    if (response.status == '200') {
                        this.wasSaved = true;
                        this.patient = response.data;
                        this.pendingChanges = false;
                        this.CountSave = 1;
                        this.edit_mode = true;
                        this.autoAssignCode = true;
                        this.EnabledItemRightMenu();
                        // this.patient.dob = this.formatterDate(this.patient.dob);
                        // this.patient.dateDeceased = this.formatterDate(this.patient.dateDeceased);
                        //  this.patient.sgDate = this.formatterDate(this.patient.sgDate);
                        if (this.$route.name !== 'Clinical') {
                            this.$router.push({ name: "patient-details", params: { id: this.patient.patientcode } });
                        }
                        this.PupulateInfoHeaderRightMenu();
                        this.EmitEventInfoHeaderRightMenu();
                        this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                            title: this.$t('Msg.Success'),
                            autoHideDelay: 5000,
                            variant: "success"
                        })
                    }
                    this.$emit('load', false);
                })
                .catch((error) => {
                    this.showResponseErrorMessage(error);
                    this.$route.router.go('/');
                });
        },

         ValidateAllDate(){
            if(this.patient.dob == ""){
                this.patient.dob = null;
            }
            if(this.patient.dateDeceased == ""){
                this.patient.dateDeceased = null;
             }
            if(this.patient.sgDate == ""){
                this.patient.sgDate = null;
             }
        },

        Save() {
            this.wasSaved = false;
            if (this.validate_required()) {
                if (this.validate_entries()) {
                    this.getModelBillToCompany();
                    this.ValidateEmptyFieldsNmeric();
                    this.ValidateAllDate();
                    EventBus.$emit('HaveChanges', false);
                    if (this.edit_mode || this.CountSave > 0) {
                        this.UpdatePatient();
                    } else {
                        const patientData = {
                            LastName: this.patient.lastname,
                            FirstName: this.patient.firstname,
                            DOB: this.patient.dob
                        }
                        PatientService.getExistPatient(patientData)
                            .then(async (response) => {
                                if (response.data.length > 0) {
                                    this.$bvModal.msgBoxConfirm(this.$t('Patient.SimilarPatientAlreadyExists', { patientcode: response.data[0].patientcode })
                                        , {
                                            title: this.$t('Patient.MatchingPatient'),
                                            okTitle: this.$t('Shared.BtnCreate'),
                                            cancelTitle: this.$t('Shared.BtnCancel'),
                                            footerClass: 'p-2',
                                            titleClass: 'modal-title modal-type-warning',
                                            id: 'modal_patient_exist'
                                        })
                                        .then(async value => {
                                            if (value) {
                                                await this.InsertPatient();
                                            } else {
                                                return;
                                            }
                                        });
                                } else {
                                    await this.InsertPatient();
                                }
                            });
                    }
                } else {
                    this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.InvalidFieldValuesDetected'), "errorAutoHide");
                }
            } else {
                this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.CheckRedLabeledFields'), "errorAutoHide");
                //  this.$route.router.go('/');
            }
        },

        onCodeConditionOk(result){
            var type = result.FieldName;
            if(type.indexOf('Referral') >= 0){
                switch (type) {
                    case "ReferralFrom":
                        this.ReferralFrom.description = result.description;
                        this.patient.referal = result.code;
                    break;
                    default:
                        this.ReferralTo.description = result.description;
                        this.patient.referalTo = result.code;
                }
            }else if(type.indexOf('Doctor') >= 0){
                switch (type) {
                    case "AttendingDoctor":
                        this.AttendingDoctor.description = result.description;
                        this.patient.doctorcode = result.code;
                    break;
                    default:
                        this.ReferringDoctor.description = result.description;
                        this.patient.privdoctorcode = result.code;
                }
            }
                else if(type.indexOf('ServiceLocation') >= 0){
                        this.ServiceLocation.description = result.description;
                        this.patient.facilitycode = result.code;
                } else if(type.indexOf('CaseManager') >= 0){
                        this.CaseManager.description = result.description;
                        this.patient.employeecode = result.code;
                }
        },

        onCodeConditionCancel(){
            this.Condition1 ? this.Condition1.code = '' : null
            this.Condition1 ? this.Condition1.description = '' : null
        },

        CallModalTable: async function (message) {
            this.$emit('load', true);
            if(message.indexOf('Referral') >= 0){
                this.TitleWindow=this.$t('Shared.Referrals');
                this.FieldsParameter = ['name','code','address1','email'];
                this.ResourceParameter = '/Referrals',
                this.TypeOption = message;
                this.fieldCode = 'code';
                this.fieldDescription = 'name';
            }else if(message.indexOf('Doctor') >= 0){
                this.TitleWindow=this.$t('Shared.Doctors');
                this.FieldsParameter = ['lastName','firstName','code'];
                this.ResourceParameter = '/Doctors',
                this.TypeOption = message;
                this.$bvModal.show('bv-modal-table-paginationServer');
                this.fieldCode = 'code';
                this.fieldDescription = 'name';
            }else if(message.indexOf('ServiceLocation') >= 0){
                this.TitleWindow=this.$t('Patient.TitleServiceLocations');
                this.FieldsParameter = ['address1','address2','code','company'];
                this.ResourceParameter = '/Facilities',
                this.TypeOption = message;
                this.fieldCode = 'code';
                this.fieldDescription = 'company';
            }else if(message.indexOf('CaseManager') >= 0){
                this.TitleWindow=this.$tc('Shared.Employee',2);
                this.FieldsParameter = ['address1','address2','code','lastName','fisrtName'];
                this.ResourceParameter = '/Employees',
                this.TypeOption = message;
                this.fieldCode = 'code';
                this.fieldDescription = 'name';
            }
            await this.$bvModal.show('bv-modal-table-paginationServer');
            this.$emit('load', false);
        },

        PupulateInfoHeaderRightMenu(){
            this.InfoPatient.Dob = this.patient.dob;
            this.InfoPatient.FirstName = this.patient.firstname;
            this.InfoPatient.LastName = this.patient.lastname;
            this.InfoPatient.Sex = this.patient.sex;
            this.InfoPatient.Age = this.patient.age;
            this.InfoPatient.Title = this.patient.title;
            this.InfoPatient.Email = this.patient.email;
            this.InfoPatient.CellPhone = this.patient.cellPhone;
            if(this.InfoPatient.Sex == 'F'){
                 this.InfoPatient.SexExtend = this.$t('Shared.Female')
            }
            if(this.InfoPatient.Sex == 'M'){
                 this.InfoPatient.SexExtend = this.$t('Shared.Male')
            }
        },

        EmitEventInfoHeaderRightMenu(){
            this.$emit('getInfoPatient', this.InfoPatient);
        },

        getPatient( id ) {
            PatientService.get( id)
            .then((response) => {
                if(response.status == '200' && response.data){
                    this.patient = response.data;

                     this.CountryModel.code = response.data.country;
                     this.CountryModel.name = response.data.country;

                     this.StateModel.code = response.data.state;
                     this.StateModel.name = response.data.state;

                     this.AreaModel.code = this.patient.homeaddressarea;
                     this.AreaModel.name = this.patient.homeaddressarea;

                     this.CityModel.code = this.patient.city;
                     this.CityModel.name = this.patient.city;

                    this.EthnicityModel.code = this.patient.ethnicityCode;
                    this.EthnicityModel.name = this.patient.ethnicityName;

                    this.BranchLocationModel.code = this.patient.branchLocation;
                    this.BranchLocationModel.description = this.patient.branchLocationDescription;

                    this.EmployModel.value = this.patient.employed;
                    this.EmployModel.text =  this.patient.employed === 'R' ? 'Retired' : this.patient.employed === 'Y' ? 'Yes' : this.patient.employed === 'N' ? 'No' : '';

                    // this.AllowEmptyUAEID = this.patient.uaeid_expdate

                    this.getLookupFieldsDesc();
                    this.PupulateInfoHeaderRightMenu();
                    this.EmitEventInfoHeaderRightMenu();
                    //this.patient.dob = this.formatterDate(this.patient.dob);
                   // this.patient.dateDeceased = this.formatterDate(this.patient.dateDeceased);
                   // this.patient.uaeid_expdate = this.formatterDate(this.patient.uaeid_expdate);
                   // this.patient.sgDate = this.formatterDate(this.patient.sgDate);
                    this.formattedCurrencyValue = this.patient.familyIncomeAmt ? "$ "+ this.patient.familyIncomeAmt : "";
                    this.formattedCurrencyValue1 = this.patient.personalIncomeAmt ? "$ "+ this.patient.personalIncomeAmt : "";
                    this.focusOut();
                    this.focusOut1();
                    this.getAgeFormatted()

                }
                 this.Loading = false;
                 this.$emit('load', this.Loading);
            })
            .catch((error) => {
              if (!error.response) {
                this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
              } else {
                this.showMessage(this.$tc('Msg.Error'),error,"error");
              }
              this.Loading = false;
              this.$emit('load', this.Loading);
            });
        },

        getLookupFieldsDesc(){
            this.ReferralFrom.description = this.patient.referalDescription;
            this.ReferralTo.description = this.patient.referalToDescription;
            this.AttendingDoctor.description = this.patient.doctorDescription;
            this.ReferringDoctor.description = this.patient.doctorPrivDescription;
            this.ServiceLocation.description = this.patient.facilityDescription;
            this.CaseManager.description = this.patient.employeeDescription;
        },

        patientZipBlur: function (value) {
            if (this.patientZipChanged && value.trim()!== '') {
            this.$emit('load', true);
            GlobalService.getCityAndStateByZipCode(value)
                .then((response) => {
                    if(response.status == '200' && response.data){
                        var obj = response.data
                       if(obj.city) {
                            this.patient.city = obj.city;
                            this.patient.state = obj.state;
                        }
                        this.patientZipChanged = false;
                    }
                     this.$emit('load', false);
                })
                .catch((error) => {
                    this.$emit('load', false);
                    this.patient.city = '';
                    this.patient.state = '';
                  if(error.response.status !== 404 && error.response.status !== 500){
                      if(error.response) {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }
                  }

                });
            }
        },

        patientZipChange: function() {
                this.patientZipChanged = true;
        },

        patientLegalZipBlur: function (value) {
            if (this.patientLegalZipChanged && value.trim()!== '') {
             this.$emit('load', true);
            GlobalService.getCityAndStateByZipCode(value)
                .then((response) => {
                    if(response.status == '200' && response.data){
                        var obj = response.data
                       if(obj.city) {
                            this.patient.legalCity = obj.city;
                            this.patient.legalState = obj.state;
                        }
                    this.patientZipChanged = false;
                    }
                    this.$emit('load', false);
                })
                .catch((error) => {
                    this.$emit('load', false);
                    this.patient.legalCity = '';
                    this.patient.legalState = '';
                   if(error.response.status !== 404 && error.response.status !== 500){
                      if(error.response) {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }
                  }
                });
            }
        },

        patientLegalZipChange: function() {
                this.patientLegalZipChanged = true;
        },

        onlyFloat (evento) {
            let keyCode = (evento.keyCode ? evento.keyCode : evento.which);
            if (this.unitSys === 'U' && (keyCode < 48 || keyCode > 57)) {
                // only allow number
                evento.preventDefault();
            } else if (this.unitSys === 'M' && (keyCode < 48 || keyCode > 57) && (keyCode == 44 )) {// 46 is dot, 44 is the comma
                // only allow number and one dot
                evento.preventDefault();
            }
        },

        ValidateEmptyFieldsNmeric(){
            if(this.patient.heights == ''){
                this.patient.heights = null;
            }
            if(this.patient.heightInches == ''){
                this.patient.heightInches = null;
            }
            if(this.patient.weight == ''){
                this.patient.weight = null;
            }
            if(this.patient.weightOunces == ''){
                this.patient.weightOunces = null;
            }
             if(this.patient.EthcodeGranularity == ''){
                this.patient.EthcodeGranularity = null;
            }
             if(this.patient.numberDependents == ''){
                this.patient.numberDependents = null;
            }
             if(this.patient.personalIncomeAmt == ''){
                this.patient.personalIncomeAmt = null;
            }
            if(this.patient.familyIncomeAmt == ''){
                this.patient.familyIncomeAmt = null;
            }
        },

        onlyInteger (evento) {
            let keyCode = (evento.keyCode ? evento.keyCode : evento.which);
            // only allow number
            if ((keyCode < 48 || keyCode > 57)) {
                evento.preventDefault();
            }
        },

        getCodeByCountry(arr,country){
            let code = "";
            for(var i = 0; i < arr.length; i++){
                if(arr[i].name && arr[i].name.toLowerCase() === country.toLowerCase()){
                    code = arr[i].code;
                    break;
                }
            }
            return code;
        },

        defaultAddValues(){
            this.patient.primaryins = "Y";
            this.patient.epsdt = false;
            this.patient.infoRelease = "Y";
            this.patient.medigapRelease = "N";
            this.patient.acceptAssign  = "C";
            this.patient.deceased  = "N";
            this.patient.student  = "N";
            this.patient.legalRep  = "N";
            this.patient.billToCompany  = false;
            this.patient.relatedToEmp  = false;
            this.patient.relatedToAuto  = false;
            this.patient.relatedToOther  = false;
            this.patient.emergency  = false;
            this.patient.military  = false;
            this.patient.enablerepeat  = "N";
            this.patient.billfortrans  = "N";
            this.patient.notActive  = "N";
            const now = new Date()
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
            this.patient.sgDate  = Utils.formatterDate(today);
            this.patient.icd9  = "N";

           if(this.$store.state.companies.Country){
            this.CountryModel.code = this.$store.state.companies.Country;
            this.CountryModel.name = this.$store.state.companies.Country;
            this.patient.country = this.CountryModel.name;
            EventBus.$emit('ChangedDrop', {model:this.CountryModel,Tag:"PatientCountry"});
            EventBus.$emit('ChangedDrop', {model:this.EthnicityModel,Tag:"PatientOrigin"});
           }
        },

        getModelBillToCompany(){
            if(this.modelBillToCompany.includes('A')){
                this.patient.billToCompany = true;
            }
            if(this.modelBillToCompany.includes('B')){
                this.patient.relatedToAuto = true;
            }
            if(this.modelBillToCompany.includes('C')){
                this.patient.relatedToOther = true;
            }
            if(this.modelBillToCompany.includes('D')){
                this.patient.military = true;
            }
            if(this.modelBillToCompany.includes('E')){
                this.patient.billfortrans = "Y";
            }
        },

        ChangeDoB() {
            this.getAgeFormatted()
        },

        getAgeFormatted() {
            if ( this.patient.dob && Utils.IsValidFieldDate(this.patient.dob)) {
                PatientService.getAgeFormatted(this.patient.dob)
                      .then((response) => {
                        if(response.status == '200'){
                            this.age = response.data;
                        }
                      })
                      .catch((error) => {
                        if(error.response) {
                            this.showMessage(this.$tc('Msg.Error'),error,"error");
                        }
                      });
            }
        },

        lookupNameByCode: function (control,value) {
             if (this.lookupFieldChanged) {
                this.getLookup(control,value);
                this.lookupFieldChanged = false;
             }
        },

        lookupFieldChange: function() {
           this.lookupFieldChanged = true;
        },

        lookupEnterEvent: function(control,value) {
            this.lookupNameByCode(control,value);
        },

        getLookup(fieldName,code) {
            let resource = '';
            if(fieldName === 'ReferralFrom'){
                resource = '/Referrals';
                this.ReferralFrom.description = '';
                this.isReferralFromValid = true;
                this.modalMessage = this.$t('Patient.InvalidReferralFromCode');
            }else if(fieldName === 'ReferralTo'){
                resource = '/Referrals';
                this.ReferralTo.description = '';
                this.isReferralToValid = true;
                this.modalMessage = this.$t('Patient.InvalidReferralToCode');
            }else if(fieldName === 'AttendingDoctor'){
                resource = '/Doctors';
                this.AttendingDoctor.description = '';
                this.isAttendingDoctorValid = true;
                this.modalMessage = this.$t('Patient.InvalidAttendingDoctor');
            }else if(fieldName === 'ReferringDoctor'){
                resource = '/Doctors';
                this.ReferringDoctor.description = '';
                this.isReferringDoctorValid = true;
                this.modalMessage = this.$t('Patient.InvalidReferringDoctor');
            }else if(fieldName.indexOf('ServiceLocation') >= 0){
                resource = '/Facilities';
                this.ServiceLocation.description = '';
                this.isServiceLocationValid = true;
                this.modalMessage = this.$t('Patient.InvalidServiceLocation');
            }else if(fieldName.indexOf('CaseManager') >= 0){
                resource = '/Employees';
                this.CaseManager.description = '';
                this.isCaseManagerValid = true;
                this.modalMessage = this.$t('Patient.InvalidCaseManager');
            }

          if (code.length > 0) {
            ModalService.get(resource,code)
             .then((response) => {
               this.lookupResult = response.data;
               if(this.lookupResult.length > 0) {
                    if(fieldName === 'ReferralFrom') {
                        this.ReferralFrom.description = this.lookupResult[0].name;
                    }else if(fieldName === 'ReferralTo'){
                        this.ReferralTo.description = this.lookupResult[0].name;
                    }else if(fieldName === 'AttendingDoctor'){
                        this.AttendingDoctor.description =
                            `${this.lookupResult[0].lastName} ${this.lookupResult[0].firstName}`;
                    }else if(fieldName === 'ReferringDoctor'){
                        this.ReferringDoctor.description =
                            `${this.lookupResult[0].lastName} ${this.lookupResult[0].firstName}`;
                    }else if(fieldName.indexOf('ServiceLocation') >= 0){
                        this.ServiceLocation.description = this.lookupResult[0].company;
                    }else if(fieldName.indexOf('CaseManager') >= 0){
                        this.CaseManager.description =
                            `${this.lookupResult[0].lastName} ${this.lookupResult[0].firstName}`;
                    }
               } else {
                    this.showMessage(this.$tc('Msg.Error'),this.modalMessage,"error");
                    if(fieldName === 'ReferralFrom') {
                        this.isReferralFromValid = false;
                    }else if(fieldName === 'ReferralTo'){
                        this.isReferralToValid = false;
                    }else if(fieldName === 'AttendingDoctor'){
                        this.isAttendingDoctorValid = false;
                    }else if(fieldName === 'ReferringDoctor'){
                        this.isReferringDoctorValid = false;
                    }else if(fieldName.indexOf('ServiceLocation') >= 0){
                        this.isServiceLocationValid = false;
                    }else if(fieldName.indexOf('CaseManager') >= 0){
                        this.isCaseManagerValid = false;
                    }
               }
            })
             .catch(error => {
                 if (error.response) {
                  this.showMessage(this.$tc('Msg.Error'),error,"error");
                 }
             });
          }
        },

        goPatientList() {
            if(!this.pendingChanges)
                this.checkExistFavorite('/app/patients');
            this.$router.push({ name: "patients-list" });
        },

        async getProvider(){
      await ProviderService.ensureVisibleSettings()
            .then((state) => {
                this.UseBlankDoctorCode = state.useBlankDoctorCode;
            })
         .catch(error => {
          if (!error.response) {
                this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                    }
                    else if(error.response.status === 400 ){
                      this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                    } else if(error.response.status === 500){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.ThereWereSomeError'),"error");
                     } else{
                         this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                     }
         });
    },

    async GetPatientByCode(){
      var infoList = await this.getInfoTitle(this.$route.params.id);
      if(infoList.length > 0){
        this.PatientTitle.programName = '';
        this.PatientTitle.admitDate = '';
        this.PatientTitle.dischargeDate = '';

        const { dob, firstname, lastname,
                age, ageFormatted } = infoList[0]; // Destructure for easier access

        if (age) this.PatientTitle.age =  age === 0 ? "0" : age;
        if (ageFormatted) this.PatientTitle.ageFormatted = ageFormatted;
        if (dob) this.PatientTitle.dob = Utils.formatterDateToString(dob);
        if (firstname) this.PatientTitle.fullName = firstname + ' '+ lastname;
      }
    },
    PopulatePatientTitle(){
        const { dob, dateFrom, dateTo, age,
                programName, patientName, ageFormatted } = this.RegistrationInfo; // Destructure for easier access

        if (dateFrom) this.RegistrationInfo.dateFrom = Utils.formatterDateToString(dateFrom);
		if (dateTo) this.RegistrationInfo.dateTo = Utils.formatterDateToString(dateTo);

        if(this.$route.name.includes('Clinical-PatientInfo')){
            if (programName) this.PatientTitle.programName = programName;
            if (dateFrom) this.PatientTitle.dateFrom = this.RegistrationInfo.dateFrom;
            if (dateTo) this.PatientTitle.dateTo = this.RegistrationInfo.dateTo;
            if (patientName) this.PatientTitle.fullName = patientName;
            if (dob) this.PatientTitle.dob = Utils.formatterDateToString(dob);
            if (age) this.PatientTitle.age = age === 0 ? "0" : age;
            if (ageFormatted) this.PatientTitle.ageFormatted = this.RegistrationInfo.ageFormatted;
        }
        if(this.$route.name.includes('patient-details')){
            this.PatientTitle.programName = '';
            this.PatientTitle.dateFrom = '';
            this.PatientTitle.dateTo = '';
            this.PatientTitle.dob = this.patient.dob;
            this.PatientTitle.fullName = this.patient.firstname + ' '+ this.patient.lastname;
        }
    },

        getDefaultDateTime() {
            this.$emit('load', true);
            GlobalService.getDateTime()
                .then((response) => {
                    if (response.data) {
                        this.patient.sgDate = Utils.formatterDate(response.data);
                    }
                    this.$emit('load', false);
                })
                .catch(error => {
                    this.$emit('load', false);
                    this.showResponseErrorMessage(error);
                });
        },

    beforeWindowUnload(e) {
			if (this.pendingChanges) {
				e.preventDefault()
				e.returnValue = ''
			}
	}
    ,
    /*checkUserAction() {
        console.log('checkUserAction', elemSaveBtn.disabled, this.pendingChanges)
      if (elemSaveBtn.disabled) {
        elemSaveBtn.removeAttribute('disabled');
      }
    },*/
    getUseAutoAssignCode(){

       PatientService.getUseAutoAssignCode("TPatientForm")
        .then((response) => {
            if (response.status == '200') {
                this.autoAssignCode = response.data
            }
         })
         .catch(error => {
          if (!error.response) {
                this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                    }
                    else if(error.response.status === 400 ){
                      this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                    } else if(error.response.status === 500){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.ThereWereSomeError'),"error");
                     } else{
                         this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                     }
         });
    },

    async getCurrentAppointment() {
      this.currentAppointmentDB = await this.geCurrentAppointment(this.$route.params.actId);
      this.PatientTitle.activitytypename  = this.currentAppointmentDB.activitytypename
      this.PatientTitle.startdatetime = `${Utils.formatterDateToString(this.currentAppointmentDB.transdate)} ${this.currentAppointmentDB.timein}`
    },
    handleEmailFieldValidation(payload) {
        if (payload.field === 'email') {
            this.emailValid = payload.isValid;
            this.patient.email = payload.value;
        }
    },

    getHasPatientWristbandSetup(){
       LetterTemplatesService.getHasPatientWristbandSetup()
        .then((response) => {
            if (response.status == '200') {
                this.hasPatientWristbandSetup = response.data
                if (!this.hasPatientWristbandSetup) {
                    const elemSaveBtn = document.getElementById('btn_save_printwristband');
                    elemSaveBtn.setAttribute('hidden', 'true');
                }
            }
         })
         .catch(error => {
          if (!error.response) {
                this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                    }
                    else if(error.response.status === 400 ){
                      this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                    } else if(error.response.status === 500){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.ThereWereSomeError'),"error");
                     } else{
                         this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                     }
         });
    },

},

    async mounted() {
        this.getHasPatientWristbandSetup()

        this.OptionsRightMenu.ItemsList = this.$route.name.includes('appointmentDB-PatientInfo') ? EnumService.AppointmentItems : EnumService.PatientItems;
        this.OptionsRightMenu.Mode = this.edit_mode;
        this.OptionsRightMenu.visible = true;
        this.IsVip = this.$store.state.IsVip;
        this.IsSpecialCase = this.$store.state.IsSpecialCase;
        moment.suppressDeprecationWarnings = true;

        this.pendingChanges = false;


        if (this.edit_mode) {
            this.OptionsRightMenu.btnvisible = true;
            this.OptionsRightMenu.itemdisabled = false;
            this.id = this.$route.params.id;
            this.$emit('load', this.Loading);
            this.getPatient(this.id);
        } else {
            this.OptionsRightMenu.btnvisible = false;
            await this.getDefaultDateTime();
            this.defaultAddValues();
            this.getUseAutoAssignCode();
        }
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
        this.isReadOnly = await this.$store.state.isPatientInfoEHRReadOnly;
        this.populateSelects();

        /*if (!this.edit_mode) {
            this.defaultAddValues();
        }*/

        if (this.$route.name.includes('patient-details') || this.$route.name.includes('appointmentDB-PatientInfo')) {
            this.GetPatientByCode();
        }

        if (this.$route.name.includes('Clinical-PatientInfo')) {
            this.RegistrationInfo = await this.getRegistrationInfoTitle(this.$route.params.recordid);

            const { dateTo, age } = this.RegistrationInfo; // Destructure for easier access
            this.IsClinical = dateTo ? false : true;
            if (age) this.RegistrationInfo.age = age === 0 ? "0" : age;
        }

        this.unitSys = this.$store.state.companies.UnitSystem ?? 'U';

        this.PopulatePatientTitle();
        if (this.$route.name.includes('appointmentDB-PatientInfo'))
            await this.getCurrentAppointment()

        /*setTimeout( function() {
             elemSaveBtn = document.getElementById('btn_save_patient');
             elemSaveBtn.setAttribute('disabled','');
         }, 50, this );*/

    },

    destroyed(){
      this.OptionsRightMenu.ItemsList = [];
      this.OptionsRightMenu.Mode = false;
      this.OptionsRightMenu.visible = false;
      this.$emit('getVisibleMenu', this.OptionsRightMenu);
    },

    async created() {
        EventBus.$on("onChanged", function (e) {
            this.pendingChanges = e.Changed;
            EventBus.$emit('HaveChanges', e.Changed);
        }.bind(this));

        EventBus.$on("onSave", function () {
            this.Save();
        }.bind(this));

        window.addEventListener('beforeunload', this.beforeWindowUnload)
        EventBus.$on('email-field-validation', this.handleEmailFieldValidation);

        this.fetchFormConfiguration(
            VUE_PROPERTY_EXCEPTIONS,
            this.$options.name,
            this.$store.state.providerCode
        )
            .then(responseData => {

                this.dsFormConfiguration = responseData;
                return this.getProvider();
                //this.populateSelects();
            })
            .catch(error => {
                this.showResponseErrorMessage(error);
            });
    },

    beforeDestroy () {
        window.removeEventListener('beforeunload', this.beforeWindowUnload);
      //EventBus.$off('onChanged');
      EventBus.$off('onSave');
      EventBus.$off('email-field-validation', this.handleEmailFieldValidation);
    },
}
</script>
